import React, { useEffect, useState, useRef, useMemo } from "react";
import MapGL, { Marker, Popup, ScaleControl } from "react-map-gl/maplibre";
import "maplibre-gl/dist/maplibre-gl.css";
import L from "leaflet";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { Source, Layer } from "react-map-gl/maplibre";
import { useLocation } from "react-router-dom";
import VisitorStats from "./VisitorStats";
import { predictSmallVesselSync } from "./predictSmallVesselSync";
import { propagateSPL } from "./One_point";

const API_BASE = "https://noisemaps.marble.eu";
// https://noisemaps.marble.eu
// "http://localhost:3001"

const REGIONS = [
   
    
    {
        name: "US_WEST_COAST_SOUTH",
        polygon: [[
            [-117.1197510, 32.4726950],
            [-117.0758057, 32.4796462],
            [-117.0153809, 32.5004965],
            [-117.0318604, 32.6486258],
            [-117.1636963, 32.8911195],
            [-117.3449707, 33.3190534],
            [-117.8530884, 33.6786399],
            [-118.1936646, 33.8567315],
            [-118.4078979, 34.0685872],
            [-118.6138916, 34.0822372],
            [-118.8912964, 34.0958849],
            [-119.1275024, 34.2140735],
            [-119.3582153, 34.3887793],
            [-119.6603394, 34.4567480],
            [-119.9267578, 34.4725994],
            [-120.2481079, 34.4975027],
            [-120.4898071, 34.5495492],
            [-120.5639648, 34.5269243],
            [-120.7479858, 34.3343645],
            [-120.6958008, 33.8795370],
            [-120.1821899, 33.5093394],
            [-119.4735718, 33.0524144],
            [-118.8967896, 32.8195949],
            [-118.3035278, 32.4587911],
            [-117.1197510, 32.4726950]
        ]]
    },

   

    {
        name: "US_EAST_COAST_NE",
        polygon: [[
            [-69.9060059, 41.6236554],
            [-68.9172363, 41.5702518],
            [-68.3239746, 41.9635748],
            [-68.7194824, 42.6582018],
            [-68.5986328, 43.3930737],
            [-68.8238525, 43.7869584],
            [-68.5546875, 43.9255937],
            [-68.8238525, 43.9809575],
            [-69.0490723, 43.9770047],
            [-69.1699219, 44.0244215],
            [-69.3511963, 44.0165213],
            [-69.5709229, 43.9928145],
            [-69.6670532, 43.9433948],
            [-69.9554443, 43.8998715],
            [-70.1641846, 43.8325455],
            [-70.2987671, 43.6718450],
            [-70.3756714, 43.5923275],
            [-70.5322266, 43.4828193],
            [-70.6201172, 43.2592059],
            [-70.7629395, 43.0568478],
            [-70.8316040, 42.9644626],
            [-70.8782959, 42.8115217],
            [-70.8453369, 42.6925299],
            [-70.6915283, 42.6198126],
            [-70.8645630, 42.5793773],
            [-70.9606934, 42.5308203],
            [-71.0513306, 42.4052066],
            [-71.1364746, 42.3362147],
            [-70.9881592, 42.1756174],
            [-70.7986450, 42.1043360],
            [-70.7409668, 42.0309342],
            [-70.6805420, 41.9145413],
            [-70.5816650, 41.8327351],
            [-70.5514526, 41.7405779],
            [-70.3564453, 41.6893223],
            [-70.0900269, 41.6790662],
            [-69.9609375, 41.6216022],
            [-69.9060059, 41.6236554]
        ]]
    },
 

    {
        name: "CARIBBEAN_PANAMA",
        polygon: [[
            [-82.5677490, 9.5520004],
            [-82.6336670, 9.4544804],
            [-82.6446533, 9.3460925],
            [-81.9854736, 8.8307952],
            [-81.1834717, 8.7385069],
            [-80.6698608, 8.9583322],
            [-80.1672363, 9.1590441],
            [-79.9035645, 9.2810435],
            [-79.6673584, 9.3704827],
            [-79.3569946, 9.4788630],
            [-78.6730957, 9.3623528],
            [-78.0303955, 9.1373510],
            [-77.7749634, 8.7602238],
            [-77.3300171, 8.3745620],
            [-77.1075439, 8.1244913],
            [-77.0635986, 7.8878679],
            [-76.7037964, 7.8960296],
            [-76.7037964, 8.3446706],
            [-76.8548584, 8.5701577],
            [-76.7230225, 8.5918844],
            [-76.4126587, 8.7547947],
            [-76.0391235, 9.2295378],
            [-75.8990479, 9.3542227],
            [-75.6271362, 9.3731926],
            [-75.5145264, 9.4544804],
            [-75.5474854, 9.6982279],
            [-75.6655884, 9.7225930],
            [-75.6518555, 9.8633341],
            [-75.6353760, 10.0932620],
            [-75.6381226, 10.1716706],
            [-75.6079102, 10.2392488],
            [-75.6353760, 10.3095149],
            [-76.2615967, 10.5904213],
            [-76.8218994, 10.7955367],
            [-77.8710938, 11.1568453],
            [-79.2169189, 11.3884943],
            [-79.7662354, 11.4208025],
            [-80.8374023, 10.9465851],
            [-81.5020752, 10.5364206],
            [-82.5677490, 9.5520004]
        ]]
    },
    {
        name: "BRAZIL_SOUTHEAST",
        polygon: [[
            [-44.6759033, -23.0645704],
            [-44.6978760, -23.0696244],
            [-44.7720337, -23.1403600],
            [-44.8928833, -23.2817192],
            [-45.0796509, -23.4355291],
            [-45.3474426, -23.5299957],
            [-45.4504395, -23.6545879],
            [-45.4298401, -23.8117317],
            [-45.5204773, -23.7778047],
            [-45.6935120, -23.7539248],
            [-45.9530640, -23.7514109],
            [-46.1000061, -23.7790614],
            [-46.2030029, -23.9448409],
            [-46.2634277, -23.9887620],
            [-46.3499451, -23.9624111],
            [-46.3732910, -23.9950352],
            [-46.4694214, -24.0000535],
            [-46.5449524, -24.0088352],
            [-46.6342163, -24.0778129],
            [-46.7509460, -24.1367282],
            [-46.8264771, -24.2118997],
            [-46.9322205, -24.2857751],
            [-46.9898987, -24.3308305],
            [-46.9473267, -24.3883781],
            [-46.9157410, -24.4258950],
            [-46.7509460, -24.5683573],
            [-46.3966370, -24.6282931],
            [-46.0807800, -24.5196384],
            [-45.4820251, -24.3070533],
            [-44.7692871, -23.9498612],
            [-44.5083618, -23.7690074],
            [-44.2529297, -23.5463631],
            [-44.3243408, -23.4141073],
            [-44.6759033, -23.0645704]
        ]]
    },

    {
        name: "EASTERN_MEDITERRANEAN",
        polygon: [[
            [28.6743164, 36.9498918],
            [28.6303711, 36.8268747],
            [26.7846680, 36.6155276],
            [24.6313477, 36.5978891],
            [23.7304688, 36.4212824],
            [23.1152344, 36.5978891],
            [22.5878906, 36.9498918],
            [21.6870117, 37.6664292],
            [21.4013672, 38.6511983],
            [20.2807617, 39.7409864],
            [19.9731445, 40.9135126],
            [20.1489258, 41.4756602],
            [19.5556641, 42.3260624],
            [18.0615234, 43.1971673],
            [16.8530273, 43.6281234],
            [15.7983398, 44.3395652],
            [14.9194336, 45.3367019],
            [14.0625000, 45.8441078],
            [12.8979492, 45.7675230],
            [12.1508789, 45.5217439],
            [12.1728516, 44.4651510],
            [12.9199219, 43.5485481],
            [13.6450195, 42.4396742],
            [15.3808594, 41.6564972],
            [16.3037109, 41.3273263],
            [17.2924805, 40.9798981],
            [18.2812500, 40.4803814],
            [18.5449219, 39.7916548],
            [18.9184570, 38.4105583],
            [19.3139648, 36.7036596],
            [19.7753906, 33.6694970],
            [20.8081055, 32.4541559],
            [21.9946289, 32.3242756],
            [23.2470703, 31.7655374],
            [24.7851563, 31.2221970],
            [26.8945313, 30.7512778],
            [29.0258789, 30.5622610],
            [30.6298828, 30.8833693],
            [31.9482422, 30.7135040],
            [33.1127930, 30.7135040],
            [34.2333984, 30.7512778],
            [34.8486328, 31.5598145],
            [35.2441406, 32.5838493],
            [35.4199219, 33.3213485],
            [36.2768555, 34.0708623],
            [36.1230469, 35.5322262],
            [36.6064453, 36.3328281],
            [36.2109375, 37.0551771],
            [35.1123047, 37.0376397],
            [33.8598633, 36.4919735],
            [32.7612305, 36.7036596],
            [30.9375000, 37.0727105],
            [29.9707031, 36.3328281],
            [28.6743164, 36.9498918]
        ]]
    },

    {
        name: "NORTH_SEA",
        polygon: [[
            [4.9218750, 53.2520688],
            [4.9438477, 53.1335898],
            [4.8449707, 52.9022759],
            [4.9768066, 52.7362917],
            [4.8559570, 52.4024189],
            [5.1525879, 52.2345283],
            [5.7568359, 52.4693968],
            [5.8117676, 52.8094028],
            [5.5371094, 53.0412130],
            [5.7897949, 53.2717835],
            [6.4270020, 53.3243115],
            [6.8774414, 53.1204053],
            [7.3278809, 53.1928702],
            [7.1740723, 53.5011170],
            [7.7453613, 53.5794615],
            [7.7453613, 53.3898808],
            [8.2177734, 53.3767750],
            [8.6791992, 53.4684307],
            [8.6132813, 53.7162156],
            [9.0856934, 53.7032105],
            [9.8767090, 53.3898808],
            [9.7998047, 53.6055441],
            [9.7009277, 53.8136258],
            [9.1296387, 53.9883951],
            [9.0966797, 54.2844688],
            [8.9758301, 54.6166171],
            [8.7011719, 54.9523857],
            [8.6132813, 55.3291444],
            [8.4155273, 55.6403990],
            [8.2727051, 56.1455495],
            [8.2727051, 56.5110175],
            [8.3715820, 56.7768083],
            [8.6352539, 56.9868976],
            [9.4262695, 57.0765747],
            [9.7009277, 57.3146574],
            [9.9975586, 57.5394168],
            [10.3051758, 57.6159917],
            [10.4699707, 57.5512080],
            [10.3271484, 57.1481607],
            [10.2941895, 56.5776409],
            [10.7226563, 56.4078234],
            [10.6347656, 56.3530776],
            [10.2832031, 56.2738614],
            [9.9096680, 55.9860915],
            [9.4702148, 55.5597092],
            [9.3383789, 55.3166430],
            [9.4482422, 54.9334543],
            [9.7119141, 54.6547686],
            [9.6350098, 54.5465795],
            [9.9096680, 54.4061431],
            [10.9094238, 54.2652241],
            [10.7336426, 54.1045021],
            [11.1181641, 53.8201118],
            [11.5576172, 53.9560855],
            [12.3486328, 54.1366965],
            [13.0517578, 54.2459704],
            [14.1503906, 53.7162156],
            [15.1062012, 53.6902014],
            [14.5678711, 54.0851734],
            [13.9746094, 54.9965243],
            [13.8427734, 55.4103072],
            [13.1286621, 55.4227790],
            [12.9968262, 55.6527980],
            [12.8320313, 56.0965558],
            [13.2055664, 56.3348115],
            [13.0407715, 56.6562265],
            [12.6232910, 56.9868976],
            [12.0739746, 57.6042214],
            [11.9421387, 58.0313724],
            [11.4038086, 58.5739811],
            [11.3269043, 59.0913824],
            [11.1840820, 59.3051603],
            [10.3601074, 59.2377960],
            [9.7338867, 58.9556744],
            [8.9099121, 58.5739811],
            [8.4265137, 58.2170249],
            [8.1738281, 58.0255552],
            [8.6022949, 57.6336399],
            [7.5695801, 57.3443098],
            [6.8115234, 56.7707884],
            [7.3168945, 55.2415520],
            [6.9104004, 54.5019475],
            [5.4602051, 53.8784404],
            [4.9218750, 53.2520688]
        ]]
    },

    {
        name: "SOUTHERN_AFRICA_MOZAMBIQUE",
        polygon: [[
            [32.8930664, -26.7701351],
            [32.7941895, -26.7995577],
            [32.6458740, -27.0591258],
            [32.5744629, -27.6300072],
            [32.3107910, -28.0768271],
            [31.9482422, -28.6954063],
            [31.5582275, -29.0705741],
            [30.9924316, -29.7453017],
            [30.6683350, -30.3681358],
            [30.3057861, -30.8692253],
            [30.0476074, -31.1940075],
            [29.7015381, -31.4239757],
            [29.4763184, -31.6861076],
            [29.5587158, -31.7515253],
            [29.9432373, -31.7888862],
            [30.7891846, -31.5036293],
            [31.3604736, -31.2738560],
            [31.8548584, -30.4202561],
            [32.5799561, -29.6068943],
            [33.3929443, -28.9745065],
            [33.6895752, -28.1252833],
            [33.5687256, -27.2106711],
            [32.8930664, -26.7701351]
        ]]
    },
    {
        name: "SOUTH_AFRICA_CAPE_TOWN",
        polygon: [[
            [18.238273933273547, -33.924084447479814],
            [18.094782395808863, -33.62046877754495],
            [17.690397153859294, -33.761566994246465],
            [17.494726875497662, -33.960157437703934],
            [17.307753053950393, -34.52449406069936],
            [17.820844006100458, -34.8748316862773],
            [18.564391063877622, -35.035203354261704],
            [19.007835203063138, -34.81413504528675],
            [18.959804008881548, -34.59246321586677],
            [18.7554793661902, -34.42409076500403],
            [18.599022775390466, -34.35952271683288],
            [18.499142753388412, -34.44922346060613],
            [18.307834276111635, -34.30567825684203],
            [18.238273933273547, -33.924084447479814]
        ]]
    },

    {
        name: "NORTH_SEA_NETHERLANDS",
        polygon: [[
            [4.034240661474229, 52.45379464271306],
            [3.6786532010060853, 52.605932195702025],
            [3.0768898063676318, 52.37037138598987],
            [2.858066753771851, 51.92438499161818],
            [2.8541591992602093, 51.71182202403543],
            [3.311343077005347, 51.91233441245515],
            [3.487183029984749, 51.876163265571705],
            [3.788064727304004, 51.87133824592286],
            [3.932644244198457, 51.87857558125407],
            [3.9209215806658335, 52.039906037405245],
            [4.065501097560343, 52.0519223497007],
            [4.1866352873896915, 52.09035284002542],
            [4.366380171759943, 52.23656535874963],
            [4.034240661474229, 52.45379464271306]
        ]]
    },

    {
        name: "PORTUGAL_WEST_COAST",
        polygon: [[
            [-9.026680253831614, 38.00303856998232],
            [-8.93368893479115, 38.32872332155773],
            [-9.105582575056644, 38.361872296377555],
            [-9.34510747771725, 38.414882440554976],
            [-9.235182567795647, 38.584698672171044],
            [-9.429639542399002, 38.65734753305313],
            [-9.67762440140234, 38.7387209113314],
            [-9.725529381933711, 38.93846002581802],
            [-9.550817099997431, 39.26647533982671],
            [-10.0749539458063, 39.30355407298114],
            [-10.430014389741075, 39.137638096475854],
            [-10.32918062508108, 38.717791597427066],
            [-10.354218723100729, 38.117012822576555],
            [-10.203990134981808, 37.71454875207573],
            [-9.440328145376782, 37.68235564076302],
            [-9.026680253831614, 38.00303856998232]
        ]]
    },

    {
        name: "SPAIN_EAST_COAST",
        polygon: [[
            [3.271812641888431, 42.08117769933045],
            [3.303982616372764, 41.71594606268431],
            [2.7972248061145137, 41.59573708983439],
            [2.4030407869040857, 41.457228194729225],
            [2.1938833714409043, 41.25797517921819],
            [1.6791026239774567, 41.16115378008399],
            [1.3251987468344737, 41.03385860403961],
            [0.9712054392524863, 40.833307578594116],
            [0.9711586764177014, 40.4609901888455],
            [1.2848832752389399, 40.2034405941946],
            [2.4995605681124005, 40.06814158381127],
            [3.191363529616382, 40.17271447533108],
            [6.071194462390082, 41.015638054891014],
            [6.513626588933363, 42.4740059539364],
            [5.7252929816374944, 42.958643405885965],
            [3.271812641888431, 42.08117769933045]
        ]]
    },
    {
        name: "GULF_OF_MEXICO_TEXAS",
        polygon: [[
            [-93.42294503977891, 29.72768485603605],
            [-93.85936811855062, 29.649385432458416],
            [-94.2815600099713, 29.521502926209024],
            [-94.62785223551876, 29.31489999236176],
            [-95.09748141811038, 28.912896566116018],
            [-95.24453702074001, 28.59266628672124],
            [-95.03581293958811, 28.317404109906064],
            [-94.49028409112323, 27.970227482041224],
            [-93.0813965433487, 28.72170823341557],
            [-93.42294503977891, 29.72768485603605]
        ]]
    },
    {
        name: "AUSTRALIA_SYDNEY_COAST",
        polygon: [[
            [151.3488869224031, -33.591927056366636],
            [151.34138269439808, -33.71277972042619],
            [151.32386716302028, -33.75233569264992],
            [151.33387345897523, -33.85423643465122],
            [151.29883417194407, -33.97885831390645],
            [151.2562774871327, -34.07842519966134],
            [151.17118159215664, -34.140594617943606],
            [151.0335552930306, -34.22547197724005],
            [150.97355140180952, -34.320573373977446],
            [150.96344403766585, -34.38881424028459],
            [150.95842551964068, -34.51059847797433],
            [150.97094030818948, -34.68160924367222],
            [151.0710586165904, -34.73099248207723],
            [151.33637213385282, -34.749503594929436],
            [151.75686902913571, -34.77212265541672],
            [151.89703465809856, -34.704246882530164],
            [152.14983335685145, -34.61571905743806],
            [152.16779809404863, -34.391795997915565],
            [152.2695443408346, -33.977398504781846],
            [152.22198815150978, -33.83429010779544],
            [152.1844437851738, -33.613623257566644],
            [152.04427815084983, -33.48846634022375],
            [151.76144392444553, -33.350584530536786],
            [151.56621321949365, -33.38821037128639],
            [151.3488869224031, -33.591927056366636]
        ]]
    }


];

const EXCLUDED_REGIONS = [
    {
        name: "EUROPE_INLAND_EXCLUDE_1",
        polygon: [[
            [-1.101943, 48.554943],
            [0.262943, 43.756972],
            [13.092549, 45.972191],
            [14.878944, 53.938109],
            [-1.101943, 48.554943]
        ]]
    },
    {
        name: "EUROPE_INLAND_EXCLUDE_2",
        polygon: [[
            [2.753389, 51.147304],
            [4.517585, 52.332310],
            [5.155262, 53.378109],
            [10.176909, 54.575666],
            [20.693891, 47.424484],
            [16.110283, 45.614428],
            [10.086119, 47.732932],
            [2.753389, 51.147304]
        ]]
    },
    {
        name: "EUROPE_INLAND_EXCLUDE_3",
        polygon: [[
            [0.023727, 49.333174],
            [0.117746, 49.601816],
            [1.694983, 49.634206],
            [1.317263, 48.250560],
            [0.023727, 49.333174]
        ]]
    },
    {
        name: "EUROPE_INLAND_EXCLUDE_4",
        polygon: [[
            [19.561218, 45.483673],
            [19.506181, 44.007269],
            [22.366143, 44.190946],
            [22.319640, 45.920890],
            [19.561218, 45.483673]
        ]]
    }


];

const buttonStyle = {
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    padding: "10px 20px",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "14px",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
    transition: "background-color 0.3s ease"
};

const buttonStyleSidebar = {
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    padding: "10px 20px",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "18px",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
    transition: "background-color 0.3s ease"
};



const getShipDescription = (type) => {
    if (type >= 60 && type <= 69) return "Passenger vessel";
    if (type >= 70 && type <= 79) return "Cargo vessel";
    if (type >= 80 && type <= 89) return "Tanker";
    if (type === 30) return "Fishing vessel";
    if (type === 36) return "Sailing vessel";
    if (type === 37) return "Pleasure craft";
    return "Unknown vessel type";
};






const ShipMap = () => {
    const [selectedShip, setSelectedShip] = useState(null);
    const navigate = useNavigate();
    const [shipData, setShipData] = useState([]);
    const [timeColumn, setTimeColumn] = useState("TIMESTAMP");
    const [currentTime, setCurrentTime] = useState(null);
    const [activeShips, setActiveShips] = useState({});
    const [minTime, setMinTime] = useState(null);
    const [maxTime, setMaxTime] = useState(null);
    const [selectedMinDate, setSelectedMinDate] = useState(null);
    const [selectedMaxDate, setSelectedMaxDate] = useState(null);
    const [showNavstat0, setShowNavstat0] = useState(true);
    const [showNavstat1, setShowNavstat1] = useState(true);
    const [zoomLevel, setZoomLevel] = useState(4);
    const [showHeatmapLegend, setShowHeatmapLegend] = useState(true);
    const [showShipIconLegend, setShowShipIconLegend] = useState(true);
    const [mapKey, setMapKey] = useState(0);
    const [showIcons, setShowIcons] = useState(true);
    const [showHeatmap, setShowHeatmap] = useState(true);
    const location = useLocation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [loginPassword, setLoginPassword] = useState("");
    const [loginError, setLoginError] = useState("");
    const [authMode, setAuthMode] = useState("login");
    const [isLoggedIn, setIsLoggedIn] = useState(() => !!sessionStorage.getItem("jwtToken"));

    const [regName, setRegName] = useState("");
    const [regEmail, setRegEmail] = useState("");
    const [regPassword, setRegPassword] = useState("");
    const [regError, setRegError] = useState("");

    const [loginEmail, setLoginEmail] = useState("");


    const [showCalcModal, setShowCalcModal] = useState(false);
    const [calcLat, setCalcLat] = useState("");
    const [calcLng, setCalcLng] = useState("");
    const [calcDepth, setCalcDepth] = useState("");
    const [calcResult, setCalcResult] = useState(null);
    const [isPickingLocation, setIsPickingLocation] = useState(false);
    const pickHintRef = useRef(null);
    const [actualDepth, setActualDepth] = useState(null);
    const [depthError, setDepthError] = useState("");
    const [noiseMin, setNoiseMin] = useState(80);
    const [noiseMax, setNoiseMax] = useState(190);
    const [selectedDepth, setSelectedDepth] = useState(0);
    const [selectedBand, setSelectedBand] = useState("63Hz");
    const [selectedModel, setSelectedModel] = useState("AVERAGE");
    const [isSelectOpen, setIsSelectOpen] = useState(false);
    const [dynamicMinSL, setDynamicMinSL] = useState(80);
    const legendTicks = useMemo(() => {
    const min = Number(noiseMin);
    const max = Number(noiseMax);

    if (!Number.isFinite(min) || !Number.isFinite(max) || max <= min) {
        return [];
    }

    const tickCount = 6;

    return Array.from({ length: tickCount }, (_, i) => {
        const value = min + (i * (max - min)) / (tickCount - 1);
        return Math.round(value);
    });
}, [noiseMin, noiseMax]);
    const depthSeaThreshold = -3;
    const [showMPA, setShowMPA] = useState(false);
    const [mpaLoading, setMpaLoading] = useState(false);

    const [regSurname, setRegSurname] = useState("");
    const [regAffiliation, setRegAffiliation] = useState("");
    const [regIntendedUse, setRegIntendedUse] = useState("Academic use");
    const [showAdminPanel, setShowAdminPanel] = useState(false);
    const [showVisitorStats, setShowVisitorStats] = useState(false);
    const [adminUsers, setAdminUsers] = useState([]);
    const [adminError, setAdminError] = useState("");
    const [deleteUserId, setDeleteUserId] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [captchaToken, setCaptchaToken] = useState("");
    const [regPasswordConfirm, setRegPasswordConfirm] = useState("");
    const [regMakeAdmin, setRegMakeAdmin] = useState(false);
    const [openedFromAdmin, setOpenedFromAdmin] = useState(false);

    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
    const [showLoginPassword, setShowLoginPassword] = useState(false);
    const [showRegisterSuccess, setShowRegisterSuccess] = useState(false);
    const intensityMultiplier = selectedModel === "SMALL_VESSEL" ? 2.0 : 1.0;
    const [mapReady, setMapReady] = useState(false);
    const [heatmapLoading, setHeatmapLoading] = useState(false);
    const SRV_RADIUS_BOOST = 1.15;
    const isSRV = selectedModel === "SMALL_VESSEL";

    const [gaussianGeoJSON, setGaussianGeoJSON] = useState(null);
    const [showGaussian, setShowGaussian] = useState(false);

    const openLogin = () => {
        setAuthMode("login");
        setLoginEmail("");
        setLoginPassword("");
        setLoginError("");
        setShowLoginModal(true);
    };

    const closeLoginModal = () => {
        setShowLoginModal(false);
        setAuthMode("login");
    };



    const loadUsers = async () => {
        try {
            const res = await fetch(`${API_BASE}/api/users`);
            const data = await res.json();

            if (data.success) {
                setAdminUsers(data.users);
            } else {
                setAdminError("Failed to load users");
            }
        } catch (err) {
            setAdminError("Server error");
        }
    };


    const deleteUser = async (id) => {

        try {
            const res = await fetch(`${API_BASE}/api/delete-user`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id })
            });

            const data = await res.json();

            if (data.success) {
                setAdminUsers(prev => prev.filter(u => u.id !== id));
            } else {
                alert("Delete failed");
            }
        } catch (err) {
            alert("Server error");
        }
    };

    async function fetchGaussianHeatmap() {
        if (!mapRef.current) return;

        const map = mapRef.current.getMap();
        const bounds = map.getBounds();

        const grid = [];
        const step = 0.05;

        for (let lat = bounds.getSouth(); lat <= bounds.getNorth(); lat += step) {
            for (let lng = bounds.getWest(); lng <= bounds.getEast(); lng += step) {
                grid.push({ lat, lng });
            }
        }

        if (grid.length === 0 || shipsForGaussian.length === 0) {
            setGaussianGeoJSON(null);
            return;
        }

        const res = await fetch(`${API_BASE}/api/gaussian-multi`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                ships: shipsForGaussian,
                grid,
                frequencyHz: 63
            })
        });

        const geojson = await res.json();
        setGaussianGeoJSON(geojson);
    }



    function isPointInPolygon(lng, lat, polygon) {
        let inside = false;
        const pts = polygon[0];

        for (let i = 0, j = pts.length - 1; i < pts.length; j = i++) {
            const xi = pts[i][0], yi = pts[i][1];
            const xj = pts[j][0], yj = pts[j][1];

            const intersect =
                ((yi > lat) !== (yj > lat)) &&
                (lng < (xj - xi) * (lat - yi) / (yj - yi) + xi);

            if (intersect) inside = !inside;
        }
        return inside;
    }

    async function fetchSoundSpeed(lat, lon, depth) {
        const res = await fetch(`${API_BASE}/api/sound-speed-profile`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify([{ lat, lon, depth }])
        });
        const data = await res.json();
        return data?.[0]?.sound_speed ?? null;
    }

    function isInAnyRegion(lng, lat) {
        return REGIONS.some(region =>
            isPointInPolygon(lng, lat, region.polygon)
        );
    }

    function isInAnyExcludedRegion(lng, lat) {
        return EXCLUDED_REGIONS.some(region =>
            isPointInPolygon(lng, lat, region.polygon)
        );
    }


    function parseAisTimestamp(ts) {
        if (!ts) return NaN;

        if (typeof ts === "number") {
            return ts < 1e12 ? ts * 1000 : ts;
        }

        if (typeof ts === "string") {
            return Date.parse(ts.replace(" ", "T") + "Z");
        }

        return NaN;
    }


    function randi_psd_perHz(f, v_knots, length_m) {
        const logf = Math.log10(f);
        const length_ft = length_m * 3.28084;

        let SL0;
        if (f <= 500) {
            const t1 = Math.pow(10, (-1.06 * logf - 14.34));
            const t2 = Math.pow(10, (3.32 * logf - 21.425));
            SL0 = -10 * Math.log10(t1 + t2);
        } else {
            SL0 = 173.2 - 18 * logf;
        }

        const df = (f <= 28.4) ? 8.1 : (22.3 - 9.77 * logf);

        const dL = Math.pow(length_ft, 1.15) / 3643.0;

        const SL = SL0
            + 60 * Math.log10(v_knots / 12)
            + 20 * Math.log10(length_ft / 300)
            + df * dL
            + 3;

        return SL;
    }
    const shipsForGaussian = shipData.map(s => ({
        source: {
            x: s.LONGITUDE * 111320 * Math.cos(s.LATITUDE * Math.PI / 180),
            y: s.LATITUDE * 111320,
            z: -5
        },
        sourceLevel: calculateNoiseByModel(s, selectedModel, selectedBand)
    }));


    function booleBandLevel_log(fc, v_knots, length_m) {
        const k = Math.pow(2, 1 / 6);
        let f_lo = fc / k;
        let f_hi = fc * k;

        const log_lo = Math.log(f_lo);
        const log_hi = Math.log(f_hi);

        const h = (log_hi - log_lo) / 4;

        const w = [7, 32, 12, 32, 7];
        let sum = 0;

        for (let i = 0; i < 5; i++) {
            const log_fi = log_lo + h * i;
            const fi = Math.exp(log_fi);

            const SL_psd = randi_psd_perHz(fi, v_knots, length_m);
            const p_lin = Math.pow(10, SL_psd / 10);

            sum += w[i] * p_lin * fi;
        }

        const integral = (2 * h / 45) * sum;
        return 10 * Math.log10(integral);
    }
    function broadbandRANDI(v_knots, length_m) {
        const centers = [
            20, 25, 31.5, 40, 50, 63, 80, 100,
            125, 160, 200, 250, 315, 400, 500,
            630, 800, 1000, 1250, 1600, 2000
        ];

        let E = 0;

        for (const fc of centers) {
            const Lb = booleBandLevel_log(fc, v_knots, length_m);
            E += Math.pow(10, Lb / 10);
        }

        return 10 * Math.log10(E);
    }


    const getSmoothShipIconSize = (zoom) => {
        if (zoom <= 3) return 8;
        if (zoom >= 13) return 24;
        const breakpoints = [
            { z: 3, size: 14 },
            { z: 6, size: 14 },
            { z: 10, size: 14 },
            { z: 13, size: 14 }
        ];
        let lower = breakpoints[0], upper = breakpoints[breakpoints.length - 1];
        for (let i = 1; i < breakpoints.length; i++) {
            if (zoom < breakpoints[i].z) {
                lower = breakpoints[i - 1];
                upper = breakpoints[i];
                break;
            }
        }
        const t = (zoom - lower.z) / (upper.z - lower.z);
        return lower.size + t * (upper.size - lower.size);
    };

    const REGION_UK = {
        minLat: -30,
        maxLat: 63,
        minLng: -130,
        maxLng: 10
    };

    const REGION_SPAIN_EUROPE = {
        minLat: 26,
        maxLat: 47,
        minLng: -13,
        maxLng: 10
    };

    const REGION_NORTH_EUROPE = {
        minLat: 47,
        maxLat: 54.2,
        minLng: 10,
        maxLng: 20
    };

    const REGION_NORTH = {
        minLat: 54.2,
        maxLat: 63,
        minLng: 3,
        maxLng: 20
    };


    const REGION_SJEVERNI_JADRAN = {
        minLat: 42,
        maxLat: 47,
        minLng: 10,
        maxLng: 20
    };

    const REGION_JUZNI_JADRAN = {
        minLat: 26,
        maxLat: 42,
        minLng: 10,
        maxLng: 20
    };



    const REGION_HAIFA_SJEVER = {
        minLat: 38,
        maxLat: 47,
        minLng: 20,
        maxLng: 38
    };

    const REGION_HAIFA_JUG = {
        minLat: -40,
        maxLat: 48,
        minLng: 0,
        maxLng: 160
    };


    const REGION_HAIFA = {
        minLat: 30,
        maxLat: 42,
        minLng: 28,
        maxLng: 37
    };

    const REGION_JADRAN = {
        minLat: 40,
        maxLat: 47,
        minLng: 12,
        maxLng: 20
    };


    const UK_EXCLUDED_REGIONS = [
        {
            minLat: 36.5,
            maxLat: 39,
            minLng: -79,
            maxLng: -76
        },
        {
            minLat: 33.88,
            maxLat: 34.21,
            minLng: -78,
            maxLng: -77.91
        },
        {
            minLat: 28.38,
            maxLat: 29.15,
            minLng: -82.15,
            maxLng: -80.95
        }
    ];

    const isInUKExcludedRegion = (lat, lng) => {
        return UK_EXCLUDED_REGIONS.some(r =>
            lat >= r.minLat &&
            lat <= r.maxLat &&
            lng >= r.minLng &&
            lng <= r.maxLng
        );
    };





    const isInRegion = (ship, region) => {
        return ship.LATITUDE >= region.minLat && ship.LATITUDE <= region.maxLat &&
            ship.LONGITUDE >= region.minLng && ship.LONGITUDE <= region.maxLng;
    };




    const db2lin = (L_dB) => Math.pow(10, L_dB / 10);
    const lin2db = (P_lin) => 10 * Math.log10(Math.max(P_lin, 1e-20));

    const K6 = Math.pow(2, 1 / 6);
    const K12 = Math.pow(2, 1 / 12);

    function thirdOctNodes(fc) {
        return [fc / K6, fc / K12, fc, fc * K12, fc * K6];
    }

    function booleWeightsLogF(fa, fb) {
        const h = (Math.log(fb) - Math.log(fa)) / 4;
        const base = [7, 32, 12, 32, 7];
        return base.map((c) => c * (2 * h) / 45);
    }

    function thirdOctBandLevel_fromPSD(psdFive_dB, fc) {
        const fNodes = thirdOctNodes(fc);
        const weights = booleWeightsLogF(fNodes[0], fNodes[4]);

        let sum = 0;
        for (let i = 0; i < 5; i++) {
            sum += weights[i] * fNodes[i] * db2lin(psdFive_dB[i]);
        }
        return lin2db(sum);
    }

    function broadband20_2000_viaThirdOct(psdFunc) {
        const centers = [
            20, 25, 31.5, 40, 50, 63, 80, 100, 125, 160,
            200, 250, 315, 400, 500, 630, 800, 1000, 1250,
            1600, 2000
        ];

        let Psum = 0;
        centers.forEach((fc) => {
            const fNodes = thirdOctNodes(fc);
            const psd5 = fNodes.map((f) => psdFunc(f));
            const bandLevel = thirdOctBandLevel_fromPSD(psd5, fc);
            Psum += db2lin(bandLevel);
        });

        return lin2db(Psum);
    }

    const HEATMAP_SOURCE_IDS = [
        "heatmap-jadran-sjever",
        "heatmap-jadran-jug",
        "ship-noise-heatmap-haifa-jug",
        "ship-noise-heatmap-haifa-sjever",
        "heatmap-uk",
        "heatmap-north"
    ];


    const mapRef = useRef(null);

    const getRealisticNoiseRadius = (noise) => {
        const thresholdDb = 50;
        const radius = Math.pow(10, (noise - thresholdDb) / 20);
        return Math.max(50, Math.min(radius, 50000));
    };

    const getRelevantVesselTypesForModel = (model) => {
        switch (model) {
            case "RANDI":
                return ["Passenger", "Cargo", "Tankers"];
            case "JOMOPANS":
                return ["Passenger", "Cargo", "Tankers", "Fishing"];
            case "LBDS":
                return ["Passenger", "Cargo", "Tankers"];
            case "AQUO":
            case "AVERAGE":
                return ["Passenger", "Cargo", "Tankers", "Sailing", "Pleasure", "Fishing"];
            case "SMALL_VESSEL":
                return ["Sailing", "Pleasure"];

            default:
                return [];
        }
    };
    function getShipCategory(type) {
        if (type >= 60 && type <= 69) return "Passenger";
        if (type >= 70 && type <= 79) return "Cargo";
        if (type >= 80 && type <= 89) return "Tankers";
        if (type === 30) return "Fishing";
        if (type === 36) return "Sailing";
        if (type === 37) return "Pleasure";
        return "Unknown";
    }
    function isVesselSupported(ship, model) {
        const category = getShipCategory(ship.AISTYPE);

        const supported = {
            RANDI: ["Passenger", "Cargo", "Tankers"],
            JOMOPANS: ["Passenger", "Cargo", "Tankers", "Fishing"],
            LBDS: ["Passenger", "Cargo", "Tankers"],
            AQUO: ["Passenger", "Cargo", "Tankers", "Sailing", "Pleasure", "Fishing"],
            AVERAGE: ["Passenger", "Cargo", "Tankers", "Sailing", "Pleasure", "Fishing"],
            SMALL_VESSEL: ["Sailing", "Pleasure"],

        };

        return supported[model]?.includes(category) ?? false;
    }


    const metersToPixelsAtLatitude = (meters, latitude, zoom) => {
        const earthCircumference = 40075016.686;
        const latitudeRadians = latitude * Math.PI / 180;
        const metersPerPixel = earthCircumference * Math.cos(latitudeRadians) / Math.pow(2, zoom + 8);
        return meters / metersPerPixel;
    };

    function getVesselLength(ship) {
        const A = Number(ship.A) || 0;
        const B = Number(ship.B) || 0;
        const ab = A + B;
        const loa =
            Number(ship.LENGTH) ||
            Number(ship.length) ||
            Number(ship.LOA) ||
            Number(ship.loa) || 0;
        const L = loa > 0 ? loa : ab;
        return Math.max(L, 10);
    }

    function getEstimatedDraught(ship) {
        const type = ship.AISTYPE;
        const length = getVesselLength(ship);
        let draught = parseFloat(ship.DRAUGHT);

        if (!isNaN(draught) && draught > 0) {
            return {
                draught: draught,
                label: `${draught.toFixed(1)} m`
            };
        }


        if (type === 36 || type === 37) {
            return {
                draught: 1,
                label: "N/A – assumed 1 m"
            };
        }

        if (type === 30) {
            return {
                draught: 3,
                label: "N/A – assumed 3 m"
            };
        }

        if (type >= 70 && type <= 79) {
            if (length < 100) {
                return { draught: 5, label: "N/A – assumed 5 m" };
            } else if (length < 150) {
                return { draught: 8, label: "N/A – assumed 8 m" };
            } else {
                return { draught: 10, label: "N/A – assumed 10 m" };
            }
        }

        if (type >= 80 && type <= 89) {
            if (length < 100) {
                return { draught: 5, label: "N/A – assumed 5 m" };
            } else if (length < 150) {
                return { draught: 8, label: "N/A – assumed 8 m" };
            } else {
                return { draught: 10, label: "N/A – assumed 10 m" };
            }
        }

        if (type >= 60 && type <= 69) {
            if (length < 50) {
                return { draught: 3, label: "N/A – assumed 3 m" };
            } else if (length < 100) {
                return { draught: 5, label: "N/A – assumed 5 m" };
            } else {
                return { draught: 8, label: "N/A – assumed 8 m" };
            }
        }

        return {
            draught: 5,
            label: "N/A – assumed 5 m"
        };
    }



    function normalizeClass(c) {
        c = c.toLowerCase();
        if (c.includes("tanker")) return "tanker";
        if (c.includes("cargo") || c.includes("container") || c.includes("bulker")) return "cargo";
        if (c.includes("passenger")) return "passenger";
        if (c.includes("fishing")) return "fishing";
        return "other";
    }

    function lsSpectralDensity_JECHO(f, vesselClass, speedKnots, lengthM) {
        const L0 = 91.44;
        const K = 191.0;
        const K_LF = 208.0;

        const VC = {
            fishing: 6.4,
            cargo: 13.9,
            tanker: 12.4,
            passenger: 9.7,
            other: 7.4
        };

        const DLF = { cargo: 0.8, tanker: 1.0 };

        vesselClass = normalizeClass(vesselClass);
        const vc = VC[vesselClass] || 7.4;

        const fhat = f / 1.0;
        const fhat1 = 480 * (1 / vc);
        const fhat1_LF = 600 * (1 / vc);

        let LS0;

        if ((vesselClass === "cargo" || vesselClass === "tanker") && f < 100) {
            const dlf = DLF[vesselClass];
            const inner = 1 - (fhat / fhat1) ** 2;
            const denom = inner ** 2 + dlf ** 2;
            LS0 = K_LF - 40 * Math.log10(fhat1_LF) + 10 * Math.log10(fhat) - 10 * Math.log10(denom);
        } else {
            const D = 3.0;
            const inner = 1 - (fhat / fhat1);
            const denom = inner ** 2 + D ** 2;
            LS0 = K - 20 * Math.log10(fhat1) - 10 * Math.log10(denom);
        }

        const speedTerm = 60 * Math.log10(speedKnots / vc);
        const lengthTerm = 20 * Math.log10(lengthM / L0);

        return LS0 + speedTerm + lengthTerm;
    }

    function booleIntegrate(func, a, b) {
        const h = (b - a) / 4;
        const f0 = func(a);
        const f1 = func(a + h);
        const f2 = func(a + 2 * h);
        const f3 = func(a + 3 * h);
        const f4 = func(b);

        return (2 * h / 45) * (7 * f0 + 32 * f1 + 12 * f2 + 32 * f3 + 7 * f4);
    }

    function thirdOctBandEdges(fc) {
        const ratio = Math.pow(10, 0.05);
        return [fc / ratio, fc * ratio];
    }

    function jomopansBand(fc, ship) {
        const [f1, f2] = thirdOctBandEdges(fc);

        const psd = (f) => {
            const L = lsSpectralDensity_JECHO(
                f,
                getShipCategory(ship.AISTYPE),
                Math.max(ship.SPEED, 0.1),
                getVesselLength(ship)
            );
            return Math.pow(10, L / 10);
        };

        const power = booleIntegrate(psd, f1, f2);
        return 10 * Math.log10(power);
    }


    function jomopansBroadband(ship) {
        const centers = [
            20, 25, 31.5, 40, 50, 63, 80, 100, 125, 160,
            200, 250, 315, 400, 500, 630, 800, 1000, 1250,
            1600, 2000
        ];

        let sum = 0;
        for (const fc of centers) {
            const L = jomopansBand(fc, ship);
            sum += Math.pow(10, L / 10);
        }
        return 10 * Math.log10(sum);
    }


    function log10(x) {
        return Math.log(x) / Math.LN10;
    }

    function lin(x) {
        return Math.pow(10, x / 10);
    }

    function dB(x) {
        return 10 * Math.log10(x);
    }


    function thirdOctNodes2(fc) {
        const ratio = Math.pow(2, 1 / 6);
        const f1 = fc / ratio;
        const f2 = fc * ratio;

        const h = (Math.log(f2) - Math.log(f1)) / 4;

        return [
            Math.exp(Math.log(f1)),
            Math.exp(Math.log(f1) + h),
            Math.exp(Math.log(f1) + 2 * h),
            Math.exp(Math.log(f1) + 3 * h),
            Math.exp(Math.log(f2))
        ];
    }



    function booleWeights() {
        return [7, 32, 12, 32, 7];
    }

    function getAQUOparams(ship) {
        const cat = getShipCategory(ship.AISTYPE);

        if (cat === "Cargo" || cat === "Tankers") {
            return {
                Lref: 180,
                Vcav: 10
            };
        }

        if (cat === "Passenger") {
            return {
                Lref: 150,
                Vcav: 12
            };
        }

        if (cat === "Fishing") {
            return {
                Lref: 80,
                Vcav: 8
            };
        }

        return {
            Lref: 180,
            Vcav: 10
        };
    }


    function SL_mach(f, V) {
        if (f < 200) {
            return 136 + 15 * log10(V);
        }
        return 186 - 22 * log10(f) + 15 * log10(V);
    }

    function SL_prop(f, V) {
        if (f < 80) {
            return 109 - 51 * log10(f) + 50 * log10(V);
        }
        return 156 - 30 * log10(f) + 50 * log10(V);
    }

    function SL_cav(f, V) {
        if (V <= 10) return null;

        if (f < 50) {
            return 79 + 10 * log10(f) + 60 * log10(V);
        }
        return 129 - 20 * log10(f) + 60 * log10(V);
    }

    function SL_total(f, V, L, params) {
        const { Lref, Vcav } = params;

        const mach = SL_mach(f, V);
        const prop = SL_prop(f, V);

        let sum = lin(mach) + lin(prop);

        if (V > Vcav) {
            const cav = SL_cav(f, V);
            sum += lin(cav);
        }

        return dB(sum) + 25 * log10(L / Lref);
    }


    function AQUO_band(fc, V, L, ship) {
        const nodes = thirdOctNodes2(fc);
        const weights = booleWeights();
        const params = getAQUOparams(ship);

        let sum = 0;
        for (let i = 0; i < 5; i++) {
            const SL = SL_total(nodes[i], V, L, params);
            sum += weights[i] * lin(SL);
        }

        const df_log = (Math.log(nodes[4]) - Math.log(nodes[0])) / 4;
        return dB((2 * df_log / 45) * sum);
    }



    function AQUO_broadband(V, L, ship) {
        const centers = [
            20, 25, 31.5, 40, 50, 63, 80, 100, 125, 160,
            200, 250, 315, 400, 500, 630, 800, 1000, 1250,
            1600, 2000
        ];

        let sum = 0;
        for (const fc of centers) {
            const Lband = AQUO_band(fc, V, L, ship);
            sum += lin(Lband);
        }

        return dB(sum);
    }


    function AQUO_sailboat(band) {
        if (band === "63Hz") return 120;
        if (band === "125Hz") return 120;
        if (band === "Broadband") return 133;
        return 120;
    }


    function SRV_model(V, L) {
        const b0 = 100.3;
        const bL = 19.1 * log10(L);
        const bV = 27.8 * log10(V);
        const bLV = (-3.1) * log10(L * V);

        return b0 + bL + bV + bLV;
    }



    function calculateNoiseByModel(ship, model, band) {


        if (!isVesselSupported(ship, model)) {
            return null;
        }

        const length = getVesselLength(ship);
        const vKnots = ship.SPEED || 0;
        const v = Math.max(vKnots, 1);
        let sourceSpl = 0;


        if (model === "RANDI") {
            const vKnots = Math.max(ship.SPEED || 0, 0.1);

            if (band === "63Hz") {
                return booleBandLevel_log(63, vKnots, length);
            }
            if (band === "125Hz") {
                return booleBandLevel_log(125, vKnots, length);
            }
            if (band === "Broadband") {
                return broadbandRANDI(vKnots, length);
            }
        }





        else if (model === "JOMOPANS") {
            if (band === "63Hz") return jomopansBand(63, ship);
            if (band === "125Hz") return jomopansBand(125, ship);
            if (band === "Broadband") return jomopansBroadband(ship);
        }







        else if (model === "LBDS") {

            function SAS4_small(f) {
                const lf = Math.log10(f);
                const df = lf - 2.70016;
                return (
                    196.26 +
                    (-10.82) * lf +
                    13.56 * (df ** 2) +
                    (-6.27) * (df ** 3) +
                    (-5.71) * (df ** 4) +
                    3.78 * (df ** 5)
                );
            }

            function SAS4_large(f, speed) {
                const lf = Math.log10(f);
                const df = lf - 2.70016;
                return (
                    174.96 +
                    (-7.42) * lf +
                    14.77 * (df ** 2) +
                    (-14.54) * (df ** 3) +
                    (-5.55) * (df ** 4) +
                    6.58 * (df ** 5) +
                    0.80 * speed
                );
            }

            const isLarge = (length > 250);
            const SPEED = ship.SPEED || 0;

            if (band === "63Hz") {
                sourceSpl = isLarge ? SAS4_large(63, SPEED) : SAS4_small(63);
            }

            else if (band === "125Hz") {
                sourceSpl = isLarge ? SAS4_large(125, SPEED) : SAS4_small(125);
            }

            else if (band === "Broadband") {
                const freqBands = [
                    20, 25, 31.5, 40, 50, 63, 80, 100, 125, 160,
                    200, 250, 315, 400, 500, 630, 800, 1000, 1250,
                    1600, 2000
                ];

                let P = 0;
                for (const f of freqBands) {
                    const SL = isLarge ? SAS4_large(f, SPEED) : SAS4_small(f);
                    P += Math.pow(10, SL / 10);
                }
                sourceSpl = 10 * Math.log10(P);
            }

        }







        if (model === "AQUO") {

            const V = Math.max(ship.SPEED || 0.1, 0.1);
            const L = getVesselLength(ship);
            const type = ship.AISTYPE;

            if (type === 36) {
                return AQUO_sailboat(band);
            }

            if (band === "63Hz") return AQUO_band(63, V, L, ship);
            if (band === "125Hz") return AQUO_band(125, V, L, ship);
            if (band === "Broadband") return AQUO_broadband(V, L, ship);
        }


        else if (model === "SMALL_VESSEL") {
            const V = Math.max(ship.SPEED || 0.1, 0.1);
            const L = getVesselLength(ship);

            const vesselType =
                ship.AISTYPE === 36 ? "sailboat" :
                    ship.AISTYPE === 37 ? "yacht" :
                        "yacht";

            const res = predictSmallVesselSync(vesselType, L, V);

            if (!res) return null;

            if (band === "63Hz") return res.L_63Hz_1_3;
            if (band === "125Hz") return res.L_125Hz_1_3;
            return res.L_20_2000Hz;
        }



        else if (model === "AVERAGE") {

            const models = ["RANDI", "JOMOPANS", "LBDS", "AQUO", "SMALL_VESSEL"];

            const weights = {
                RANDI: 1.0,
                JOMOPANS: 1.0,
                LBDS: 0.9,
                AQUO: 1.0,
                SMALL_VESSEL: 0.9
            };

            let Psum = 0;
            let wsum = 0;

            for (const m of models) {
                const LdB = calculateNoiseByModel(ship, m, band);

                if (!isFinite(LdB)) continue;

                const P = Math.pow(10, LdB / 10);   
                Psum += weights[m] * P;
                wsum += weights[m];
            }

            if (wsum > 0 && Psum > 0) {
                sourceSpl = 10 * Math.log10(Psum / wsum);
            } else {
                sourceSpl = null;
            }
        }











        return sourceSpl;
    }






    function haversineDistance(lat1, lon1, lat2, lon2) {
        function toRad(x) { return x * Math.PI / 180; }
        const R = 6371000;
        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    const handleCalculate = () => {
        const lat = parseFloat(calcLat);
        const lng = parseFloat(calcLng);

        const userDepth = parseFloat(calcDepth);
        const userDepthSigned = isNaN(userDepth) ? 0 : -Math.abs(userDepth);
        if (actualDepth === null || !isFinite(actualDepth)) {
            setDepthError("No bathymetry data available for this area.");
            return;
        }

        if (actualDepth !== null && userDepthSigned < actualDepth) {
            setDepthError(`Entered depth (${userDepthSigned} m) is shallower than the actual depth (${actualDepth.toFixed(2)} m)`);
            return;
        } else {
            setDepthError("");
        }

        let maxSpl = null;
        let maxShip = null;

        shipData.forEach(ship => {
            const horizontalDist = haversineDistance(
                lat,
                lng,
                ship.LATITUDE,
                ship.LONGITUDE
            );

            const sourceSpl = calculateNoiseByModel(
                ship,
                selectedModel,
                selectedBand
            );

            if (sourceSpl === null || !isFinite(sourceSpl)) return;

            const splAtPoint =
                sourceSpl - 20 * Math.log10(Math.max(horizontalDist, 1));

            if (maxSpl === null || splAtPoint > maxSpl) {
                maxSpl = splAtPoint;
                maxShip = ship;
            }
        });

        setCalcResult({
            spl: maxSpl + 45,
            ship: maxShip
        });
    };





    const handleRegister = async (e) => {
        e.preventDefault();

        if (regPassword !== regPasswordConfirm) {
            setRegError("Passwords do not match.");
            return;
        }

        const strongPassword =
            /[A-Z]/.test(regPassword) &&
            /[0-9]/.test(regPassword) &&
            regPassword.length >= 8;

        if (!strongPassword) {
            setRegError("Password must be at least 8 characters long<br/>and include one uppercase letter and one number.");
            return;
        }


        if (!captchaToken) {
            setRegError("Please complete the captcha first.");
            return;
        }

        setRegError("");

        try {
            const res = await fetch(`${API_BASE}/api/register`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    name: regName,
                    surname: regSurname,
                    email: regEmail,
                    password: regPassword,
                    affiliation: regAffiliation,
                    intended_use: regIntendedUse,
                    role: regMakeAdmin ? "admin" : "user",
                    captcha: captchaToken

                })
            });

            const data = await res.json();

            if (!data.success) {
                setRegError(data.error || "Registration failed");
                return;
            }


            if (data.success) {
                setShowRegisterSuccess(true);
            }

            if (openedFromAdmin) {
                setShowLoginModal(false);
                setOpenedFromAdmin(false);
                return;
            }

            setAuthMode("login");
            setLoginEmail(regEmail);
            setLoginPassword("");

        } catch (err) {
            setRegError("Server error");
        }
    };


    const handleLogin = async (e) => {
        e.preventDefault();
        setLoginError("");

        try {
            const res = await fetch(`${API_BASE}/api/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    email: loginEmail,
                    password: loginPassword
                })
            });

            const data = await res.json();

            if (!data.success) {
                setLoginError(data.error || "Incorrect email or password");
                return;
            }

            sessionStorage.setItem("jwtToken", data.token);
            sessionStorage.setItem("user", JSON.stringify(data.user));

            setIsLoggedIn(true);


            setShowLoginModal(false);
            setLoginEmail("");
            setLoginPassword("");
        } catch (err) {
            setLoginError("Server error");
        }
    };

    const user = JSON.parse(sessionStorage.getItem("user"));







    const getDynamicMinSourceLevel = () => {
        const movingShips = shipData.filter(ship =>
            typeof ship.SPEED === "number" && ship.SPEED >= 2
        );

        if (movingShips.length === 0) return noiseMin;

        let minSL = Infinity;

        for (const ship of movingShips) {
            const sl = calculateNoiseByModel(ship, selectedModel, selectedBand);

            if (sl === null || !isFinite(sl)) continue;

            minSL = Math.min(minSL, sl);
        }

        return isFinite(minSL) ? Math.round(minSL) : noiseMin;
    };




    const generateHeatmapGeoJSON = async () => {
        const currentTimestamp = currentTime ? currentTime.getTime() : null;
        const allowedTypes = [30, 36, 37];
        for (let i = 60; i <= 89; i++) allowedTypes.push(i);

        const allowedAISNavstats = [0, 2, 3, 4, 7];
        const validShips = shipData.filter((ship) => {
            if (!allowedAISNavstats.includes(ship.NAVSTAT)) return false;
            if (typeof ship.SPEED !== "number" || ship.SPEED < 2) return false;

            if (!currentTimestamp || !ship[timeColumn]) return false;

            const shipTime = new Date(ship[timeColumn]).getTime();
            if (isNaN(shipTime)) return false;

            if (
                location.pathname === "/live_ais_data" ||
                location.pathname === "/"
            ) {
                return true;
            }

        });



        const uniqueShips = Object.values(
            validShips.reduce((acc, ship) => {
                acc[ship.MMSI] = ship;
                return acc;
            }, {})
        );


        const createFeatures = (region) =>
            uniqueShips
                .filter(ship => {

                    if (isInUKExcludedRegion(ship.LATITUDE, ship.LONGITUDE)) {
                        return false;
                    }

                    return isInRegion(ship, region);
                })
                .flatMap((ship) => {
                    const heatmapZoom = 10;
                    const lat0 = ship.LATITUDE;
                    const lon0 = ship.LONGITUDE;


                    if (
                        typeof ship.SPEED !== "number" ||
                        typeof ship.A !== "number" ||
                        typeof ship.B !== "number" ||
                        typeof lat0 !== "number" ||
                        typeof lon0 !== "number"
                    ) return [];


                    let noise = calculateNoiseByModel(ship, selectedModel, selectedBand);
                    if (selectedDepth > 0) {
                        const depth = selectedDepth;
                        noise = noise - 20 * Math.log10(depth);
                    }


                    let originalNoise = noise;

                    if (!isFinite(originalNoise)) return [];
                    if (originalNoise < noiseMin || originalNoise > noiseMax) return [];

                    const sourceDepth = 5;
                    const verticalDist = Math.abs(selectedDepth - sourceDepth);

                    const baseRadius = getRealisticNoiseRadius(noise);
                    const radius = Math.sqrt(baseRadius ** 2 + verticalDist ** 2);


                    if (!isFinite(noise)) return [];


                    const MIN_COMBINED_SPL = 165;

                    if (selectedModel === "AVERAGE") {
                        if (!isFinite(noise)) noise = MIN_COMBINED_SPL;
                        else noise = Math.max(noise, MIN_COMBINED_SPL);
                    }




                    const radiusPixels = metersToPixelsAtLatitude(radius, lat0, heatmapZoom);
                    if (!isFinite(radiusPixels)) return [];

                    const numRays = 20;
                    const angles = Array.from({ length: numRays }, (_, i) => i * 18);


                    const weight = Math.max(0, (noise - noiseMin) / (noiseMax - noiseMin)) / numRays;

                    const metersPerDegLat = 111320;
                    const metersPerDegLng = 111320 * Math.cos(lat0 * Math.PI / 180);

                    const rayRings = [0.25, 0.50, 0.75, 1.0];

                    let rayFeatures = [];

                    for (const ring of rayRings) {
                        const rayDistanceRing = baseRadius * ring;

                        for (const a of angles) {
                            const rad = (a * Math.PI) / 180;

                            const newLat = lat0 + (rayDistanceRing / metersPerDegLat) * Math.sin(rad);
                            const newLng = lon0 + (rayDistanceRing / metersPerDegLng) * Math.cos(rad);

                            if (ship.MMSI === 312004000) {
                                console.log(
                                    `%cRAY | MMSI ${ship.MMSI} | ring=${ring} | angle=${a}° | lat=${newLat} | lon=${newLng}`,
                                    "color: #00aaff; font-weight: bold;"
                                );
                            }

                            rayFeatures.push({
                                type: "Feature",
                                geometry: { type: "Point", coordinates: [newLng, newLat] },
                                properties: {
                                    noise,
                                    radius: radiusPixels,
                                    normalizedNoise: Math.max(0, (noise - noiseMin) / (noiseMax - noiseMin)),
                                    weight: weight / rayRings.length,
                                    angle: a,
                                    ring
                                }
                            });
                        }
                    }


                    const lonelyRadius = 20000;
                    let neighboringShips = 0;

                    for (const otherShip of uniqueShips) {
                        if (otherShip.MMSI === ship.MMSI) continue;

                        const dx = (otherShip.LONGITUDE - lon0) * 111320 * Math.cos(lat0 * Math.PI / 180);
                        const dy = (otherShip.LATITUDE - lat0) * 111320;
                        const dist = Math.sqrt(dx * dx + dy * dy);

                        if (dist < lonelyRadius) {
                            neighboringShips++;
                            break;
                        }
                    }

                    let boostFactor = 1;
                    if (neighboringShips === 0) {
                        boostFactor = 3;
                    }

                    rayFeatures.forEach(f => {
                        f.properties.weight *= boostFactor;
                    });

                    return rayFeatures;


                });



        const normalize = (features) => {
            if (!features.length) return features;

            features.forEach(f => {
                const n = f.properties.noise;
                let normalized = (n - noiseMin) / (noiseMax - noiseMin);
                f.properties.normalizedNoise = Math.max(0, Math.min(1, normalized));
            });

            return features;
        };

       


        async function filterDepthForRegion(featureCollection) {
            const features = featureCollection.features;
            if (!features.length) return featureCollection;

            const body = features.map(f => ({
                lat: f.geometry.coordinates[1],

                lon: f.geometry.coordinates[0]
            }));

            let depthData;
            try {
                const resp = await fetch(`${API_BASE}/api/depths`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(body)
                });
                depthData = await resp.json();


            } catch (err) {
                console.error("Depth API error:", err);
                return featureCollection;
            }

            if (!depthData.depths) return featureCollection;

            const filtered = features.filter((f, i) => {
                const d = depthData.depths[i];

                if (d === null || d === undefined || isNaN(d)) return false;

                if (d < depthSeaThreshold) return true;

                return false;
            });




            return {
                type: "FeatureCollection",
                features: filtered
            };
        }




        const sjeverni = await filterDepthForRegion({
            type: "FeatureCollection",
            features: normalize(createFeatures(REGION_SJEVERNI_JADRAN))
        });

        const juzni = await filterDepthForRegion({
            type: "FeatureCollection",
            features: normalize(createFeatures(REGION_JUZNI_JADRAN))
        });

        const jadranReg = await filterDepthForRegion({
            type: "FeatureCollection",
            features: normalize(createFeatures(REGION_JADRAN))
        });

        const haifaReg = await filterDepthForRegion({
            type: "FeatureCollection",
            features: normalize(createFeatures(REGION_HAIFA))
        });

        const haifaSjeverReg = await filterDepthForRegion({
            type: "FeatureCollection",
            features: normalize(createFeatures(REGION_HAIFA_SJEVER))
        });

        const haifaJugReg = await filterDepthForRegion({
            type: "FeatureCollection",
            features: normalize(createFeatures(REGION_HAIFA_JUG))
        });

        const ukReg = await filterDepthForRegion({
            type: "FeatureCollection",
            features: normalize(createFeatures(REGION_UK))
        });

        const spainRegion = await filterDepthForRegion({
            type: "FeatureCollection",
            features: normalize(createFeatures(REGION_SPAIN_EUROPE))
        });



        const northEuropeReg = await filterDepthForRegion({
            type: "FeatureCollection",
            features: normalize(createFeatures(REGION_NORTH_EUROPE))
        });

        const northReg = await filterDepthForRegion({
            type: "FeatureCollection",
            features: normalize(createFeatures(REGION_NORTH))
        });

        return {
            sjeverni_jadran: sjeverni,
            juzni_jadran: juzni,
            jadran: jadranReg,
            haifa: haifaReg,
            haifa_sjever: haifaSjeverReg,
            haifa_jug: haifaJugReg,
            uk: ukReg,
            spain_region: spainRegion,
            north_europe: northEuropeReg,
            north: northReg
        };


    };



    const [heatmapData, setHeatmapData] = useState({
        jadran: { features: [] },
        haifa: { features: [] },
        sjeverni_jadran: { features: [] },
        juzni_jadran: { features: [] },
        haifa_sjever: { features: [] },
        haifa_jug: { features: [] },
        uk: { features: [] },
        spain_region: { features: [] },
        north_europe: { features: [] },
        north: { features: [] }
    });

    useEffect(() => {
        if (!mapReady) return;
        if (!showHeatmap) return;
        if (shipData.length === 0) return;

        let cancelled = false;

        (async () => {
            setHeatmapLoading(true);

            const result = await generateHeatmapGeoJSON();

            if (!cancelled) {
                setHeatmapData(result);

                requestAnimationFrame(() => {
                    setHeatmapLoading(false);
                });
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [
        mapReady,
        showHeatmap,
        shipData,
        showNavstat0,
        showNavstat1,
        currentTime,
        noiseMin,
        noiseMax,
        selectedBand,
        selectedModel,
        selectedDepth
    ]);


    const {

        sjeverni_jadran,
        juzni_jadran,
        haifa_sjever,
        haifa_jug,
        uk,
        spain_region,
        north_europe,
        north
    } = heatmapData;







    useEffect(() => {
        const fetchLiveAIS = async () => {
            try {
                const res = await fetch(`${API_BASE}/api/live-ais`);
                const data = await res.json();

                const now = new Date();

                const ships = Array.isArray(data.ships) ? data.ships : Array.isArray(data) ? data : [];

                const parsedShips = ships
                    .filter(ship => ship.AIS)
                    .filter(ship => {
                        const lat = ship.AIS.LATITUDE;
                        const lng = ship.AIS.LONGITUDE;

                        if (!isFinite(lat) || !isFinite(lng)) return false;
                        if (!isInAnyRegion(lng, lat)) return false;
                        if (isInAnyExcludedRegion(lng, lat)) return false;

                        return true;
                    })
                    .map(ship => {
                        const s = ship.AIS;
                        return {
                            MMSI: s.MMSI,
                            LATITUDE: s.LATITUDE,
                            LONGITUDE: s.LONGITUDE,
                            SPEED: s.SPEED,
                            COURSE: s.COURSE,
                            HEADING: s.HEADING,
                            NAVSTAT: s.NAVSTAT,
                            IMO: s.IMO,
                            NAME: s.NAME,
                            CALLSIGN: s.CALLSIGN,
                            AISTYPE: s.TYPE,
                            A: s.A,
                            B: s.B,
                            C: s.C,
                            D: s.D,
                            DRAUGHT: s.DRAUGHT,
                            DESTINATION: s.DESTINATION,
                            ETA: s.ETA,
                            TIMESTAMP: s.TIMESTAMP
                        };
                    });


                setShipData(parsedShips);




                setCurrentTime(now);
                setMinTime(now.getTime() - 30 * 60 * 1000);
                setMaxTime(now.getTime());
                setSelectedMinDate(now);
                setSelectedMaxDate(now);
            } catch (err) {
                console.error("Error fetching live AIS data:", err);
            }
        };

        fetchLiveAIS();
        const interval = setInterval(fetchLiveAIS, 65000);
        return () => clearInterval(interval);
    }, []);



    useEffect(() => {
        setCurrentTime(new Date());
        const interval = setInterval(() => {
            setCurrentTime(new Date());
        }, 60000);
        return () => clearInterval(interval);
    }, []);



    useEffect(() => {
        const allowedTypes = [30, 36, 37];
        for (let i = 60; i <= 89; i++) allowedTypes.push(i);

        const allowedAISNavstats = [0, 2, 3, 4, 7];

        const now = Date.now();
        const TWENTY_MINUTES = 20 * 60 * 1000;

        const updatedShips = {};

        shipData.forEach(row => {
            const speedKnots = typeof row.SPEED === "number" ? row.SPEED : 0;

            const isAnchor = speedKnots < 2;
            const isUnderway = speedKnots >= 2;

            if (isAnchor && !showNavstat0) return;
            if (isUnderway && !showNavstat1) return;

            if (!allowedTypes.includes(row.AISTYPE)) return;
            if (!allowedAISNavstats.includes(row.NAVSTAT)) return;


            const tsRaw = row[timeColumn];
            const timestamp = parseAisTimestamp(tsRaw);

            if (!isFinite(timestamp)) return;
            if (now - timestamp > TWENTY_MINUTES) return;
          
          
         /*   const lat = row.LATITUDE;
            const lng = row.LONGITUDE;

            if (!isFinite(lat) || !isFinite(lng)) return;

            if (!isInAnyRegion(lng, lat)) return;

            if (isInAnyExcludedRegion(lng, lat)) return;
            
        */

            updatedShips[String(row.MMSI)] = row;
        });


        setActiveShips(updatedShips);
    }, [shipData, showNavstat0, showNavstat1, currentTime]);


    useEffect(() => {
        const onKeyDown = (ev) => {
            if (ev.key === "Escape" && isPickingLocation) {
                setIsPickingLocation(false);
                const map = mapRef.current?.getMap();
                if (map) map.getCanvas().style.cursor = "";
                if (pickHintRef.current) pickHintRef.current.style.display = "none";
            }
        };
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [isPickingLocation]);




    useEffect(() => {
        const newMinSL = getDynamicMinSourceLevel();
        setDynamicMinSL(newMinSL);
    }, [activeShips, selectedModel, selectedBand, currentTime]);


    useEffect(() => {
        const map = mapRef.current?.getMap();
        if (!map) return;

        const onData = (e) => {
            if (!showMPA) return;
            if (e.sourceId === "mpa" && e.isSourceLoaded) {
                setMpaLoading(false);
            }
        };



        map.on("sourcedata", onData);

        return () => map.off("sourcedata", onData);

    }, [showMPA]);
    useEffect(() => {
        const newMinSL = getDynamicMinSourceLevel();
        setDynamicMinSL(newMinSL);
    }, [activeShips, selectedModel, selectedBand, currentTime]);


    useEffect(() => {
        if (showLoginModal && authMode === "register") {
            setTimeout(() => {
                if (window.grecaptcha && document.getElementById("recaptcha-register")) {
                    window.grecaptcha.render("recaptcha-register", {
                        sitekey: "6LcWBh4sAAAAAFk5yuvXn7hkE0wV-uAmh1dQi2Xz",
                        callback: (token) => setCaptchaToken(token)
                    });
                }
            }, 50);
        }
    }, [showLoginModal, authMode]);


    useEffect(() => {
        if (showLoginModal) {
            if (authMode === "register") {
                setRegName("");
                setRegSurname("");
                setRegEmail("");
                setRegPassword("");
                setRegPasswordConfirm("");
                setRegAffiliation("");
                setRegIntendedUse("Academic use");
                setCaptchaToken("");
                setRegError("");
            }

            if (authMode === "login") {
                setLoginEmail("");
                setLoginPassword("");
                setLoginError("");
            }
        }
    }, [showLoginModal, authMode]);


    useEffect(() => {
        document.title = "Live noise map";
    }, []);


    useEffect(() => {
        const handler = (e) => {
            setCaptchaToken(e.detail);
        };

        window.addEventListener("captcha-done", handler);

        return () => window.removeEventListener("captcha-done", handler);
    }, []);

    useEffect(() => {
        if (!showLoginModal) {
            setShowPassword(false);
            setShowPasswordConfirm(false);
            setShowLoginPassword(false);
        }
    }, [showLoginModal]);

    useEffect(() => {
        setShowPassword(false);
        setShowPasswordConfirm(false);
        setShowLoginPassword(false);
    }, [authMode, openedFromAdmin]);


    useEffect(() => {
        if (!showHeatmap) return;

        setHeatmapLoading(true);
    }, [selectedModel, selectedBand, currentTime, showHeatmap]);



useEffect(() => {
    const map = mapRef.current?.getMap();
    if (!map || !showHeatmap || !heatmapLoading) return;

    const loadedSources = new Set();

    const onSourceData = (e) => {
        if (
            e.sourceId &&
            HEATMAP_SOURCE_IDS.includes(e.sourceId) &&
            e.isSourceLoaded
        ) {
            loadedSources.add(e.sourceId);

            if (loadedSources.size === HEATMAP_SOURCE_IDS.length) {
                setHeatmapLoading(false);
                map.off("sourcedata", onSourceData);
            }
        }
    };

    map.on("sourcedata", onSourceData);

    return () => {
        map.off("sourcedata", onSourceData);
    };
}, [heatmapLoading, showHeatmap]);


    useEffect(() => {
        if (!showGaussian) return;
        if (!selectedShip) return;
        if (!mapReady) return;

        fetchGaussianHeatmap();

    }, [
        showGaussian,
        selectedShip,
        selectedBand,
        mapReady
    ]);


    useEffect(() => {
        if (!showGaussian) {
            setGaussianGeoJSON(null);
            return;
        }

        if (!shipData || shipData.length === 0) return;

        fetchGaussianHeatmap();
    }, [showGaussian, shipData, selectedModel, selectedBand]);


    /*
        useEffect(() => {
            const ships = Object.values(activeShips || {});
    
            const srvShips = ships.filter(
                ship => ship.AISTYPE === 36 || ship.AISTYPE === 37
            );
    
            const navstatCount = {};
    
            console.group("🟢 ACTIVE SRV VESSELS (AIS 36 & 37)");
    
            srvShips.forEach(ship => {
                const nav = ship.NAVSTAT;
    
                navstatCount[nav] = (navstatCount[nav] || 0) + 1;
    
                console.log({
                    MMSI: ship.MMSI,
                    NAME: ship.NAME,
                    AISTYPE: ship.AISTYPE,
                    NAVSTAT: ship.NAVSTAT,
                    SPEED: ship.SPEED
                });
            });
    
            console.group("📊 NAVSTAT SUMMARY");
            Object.keys(navstatCount)
                .sort((a, b) => Number(a) - Number(b))
                .forEach(nav => {
                    console.log(`NAVSTAT ${nav}: ${navstatCount[nav]} plovila`);
                });
            console.groupEnd();
    
            console.log("TOTAL SRV ON SCREEN:", srvShips.length);
            console.groupEnd();
    
        }, [activeShips]);
    */

    const getCellSizeDeg = (zoom) => {
        if (zoom <= 2) return 5;
        if (zoom <= 4) return 2;
        if (zoom <= 5) return 1;
        if (zoom <= 6) return 0.5;
        if (zoom <= 7) return 0.25;
        return 0;
    };


    const visibleShips = useMemo(() => {
        const ships = Object.values(activeShips);
        if (ships.length === 0) return [];

        if (zoomLevel >= 8) {
            return ships;
        }

        const cellSize = getCellSizeDeg(zoomLevel);
        const cellGrid = new Map();

        for (const ship of ships) {
            const x = Math.floor(ship.LONGITUDE / cellSize);
            const y = Math.floor(ship.LATITUDE / cellSize);
            const key = `${x}_${y}`;

            if (!cellGrid.has(key)) {
                cellGrid.set(key, []);
            }

            cellGrid.get(key).push(ship);
        }

        const result = [];

        const maxPerCell =
            zoomLevel <= 2 ? 1 :
                zoomLevel <= 4 ? 2 :
                    zoomLevel <= 6 ? 4 :
                        10;

        for (const cellShips of cellGrid.values()) {
            result.push(...cellShips.slice(0, maxPerCell));
        }

        return result;
    }, [activeShips, zoomLevel]);



    const selectBoxStyle = {
        width: "100%",
        padding: "10px 12px",
        borderRadius: "8px",
        border: "1px solid #cbd5e1",
        background: "#fff",
        fontSize: "14px",
        color: "#222",
        boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
        outline: "none",
        transition: "border-color .2s ease, box-shadow .2s ease, background-color .2s ease",
        cursor: "pointer",
    };


    const getShipIcon = (type, course) => {
        let iconSrc = "IconPurple1.png";
        let size = 15;

        if (type >= 60 && type <= 69) {
            iconSrc = "IconBlue1.png";
            size = 22;
        } else if (type >= 70 && type <= 79) {
            iconSrc = "IconYellow1.png";
            size = 24;
        } else if (type >= 80 && type <= 89) {
            iconSrc = "IconGray1.png";
            size = 26;
        } else if (type === 36) {
            iconSrc = "IconRed1.png";
            size = 15;
        } else if (type === 37) {
            iconSrc = "IconOrange1.png";
            size = 15;
        } else if (type === 30) {
            iconSrc = "IconPurple1.png";
            size = 15;
        }



        return L.divIcon({
            html: `<img src="${iconSrc}" style="width:${size}px; height:${size}px; transform: rotate(${course}deg);"/>`,
            className: "custom-ship-icon",
            iconSize: [size, size],
            iconAnchor: [size / 2, size / 2],
            popupAnchor: [0, -size / 2]
        });
    };

    return (

        <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
            {showLoginModal && (

                <div
                    style={{
                        position: "fixed",
                        top: 0, left: 0, right: 0, bottom: 0,
                        background: "rgba(0,0,0,0.4)",
                        zIndex: 5000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    onClick={closeLoginModal}
                >
                    <form
                        onClick={(e) => e.stopPropagation()}
                        onSubmit={authMode === "login" ? handleLogin : handleRegister}
                        style={{
                            background: "#fff",
                            padding: "35px 25px 25px 25px",
                            borderRadius: "14px",
                            boxShadow: "0 6px 24px rgba(0,0,0,0.21)",
                            minWidth: 365,
                            display: "flex",
                            flexDirection: "column",
                            gap: 12.5,
                            position: "relative"
                        }}
                    >

                        <div
                            onClick={closeLoginModal}
                            style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                fontSize: "22px",
                                cursor: "pointer",
                                color: "#777",
                                fontWeight: "bold",
                                lineHeight: "1"
                            }}
                        >
                            ×
                        </div>


                        <h2 style={{ margin: 0, marginBottom: 12, textAlign: "center" }}>
                            {authMode === "login" ? "Login" : "Create account"}
                        </h2>

                        {authMode === "login" ? (

                            <>




                                <input
                                    type="email"
                                    placeholder="Email"
                                    value={loginEmail}
                                    onChange={e => setLoginEmail(e.target.value)}
                                    required
                                    style={{ padding: 8, fontSize: 16, borderRadius: 6, border: "1px solid #ccc" }}
                                />
                                <div style={{ position: "relative", width: "100%" }}>
                                    <input
                                        type={showLoginPassword ? "text" : "password"}
                                        placeholder="Password"
                                        value={loginPassword}
                                        onChange={e => setLoginPassword(e.target.value)}
                                        required
                                        style={{
                                            padding: "8px 36px 8px 9px",
                                            fontSize: 16,
                                            borderRadius: 6,
                                            border: "1px solid #ccc",
                                            width: "100%",
                                            boxSizing: "border-box"
                                        }}
                                    />

                                    <img
                                        src={showLoginPassword ? "/hide.png" : "/show.png"}
                                        alt="toggle visibility"
                                        onClick={() => setShowLoginPassword(prev => !prev)}
                                        style={{
                                            position: "absolute",
                                            right: 10,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            width: 20,
                                            height: 20,
                                            cursor: "pointer",
                                            opacity: 0.7
                                        }}
                                    />
                                </div>


                                {loginError && (
                                    <div style={{ color: "red", textAlign: "center", fontSize: 14 }}>
                                        {loginError}
                                    </div>
                                )}

                                <button type="submit" style={{ ...buttonStyle, width: "100%" }}>
                                    Login
                                </button>

                                <button
                                    type="button"
                                    onClick={() => setAuthMode("register")}
                                    style={{
                                        ...buttonStyle,
                                        backgroundColor: "#ccc",
                                        color: "#222",
                                        width: "100%"
                                    }}
                                >
                                    Create account
                                </button>
                            </>
                        ) : (
                            <>
                                {user && user.role === "admin" && (
                                    <label style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "10px" }}>
                                        <input
                                            type="checkbox"
                                            checked={regMakeAdmin}
                                            onChange={(e) => setRegMakeAdmin(e.target.checked)}
                                        />
                                        Make this user an administrator
                                    </label>
                                )}

                                <input
                                    type="text"
                                    placeholder="Name"
                                    value={regName}
                                    onChange={e => setRegName(e.target.value)}
                                    required
                                    style={{ padding: 8, fontSize: 16, borderRadius: 6, border: "1px solid #ccc" }}
                                />

                                <input
                                    type="text"
                                    placeholder="Surname"
                                    value={regSurname}
                                    onChange={e => setRegSurname(e.target.value)}
                                    required
                                    style={{ padding: 8, fontSize: 16, borderRadius: 6, border: "1px solid #ccc" }}
                                />

                                <input
                                    type="email"
                                    placeholder="Email"
                                    value={regEmail}
                                    onChange={e => setRegEmail(e.target.value)}
                                    required
                                    style={{ padding: 8, fontSize: 16, borderRadius: 6, border: "1px solid #ccc" }}
                                />


                                <div style={{ position: "relative", width: "100%" }}>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        placeholder="Password"
                                        value={regPassword}
                                        onChange={e => setRegPassword(e.target.value)}
                                        required
                                        style={{
                                            padding: "8px 36px 8px 9px",
                                            fontSize: 16,
                                            borderRadius: 6,
                                            border: "1px solid #ccc",
                                            width: "100%",
                                            boxSizing: "border-box"
                                        }}
                                    />

                                    <img
                                        src={showPassword ? "/hide.png" : "/show.png"}
                                        alt="toggle visibility"
                                        onClick={() => setShowPassword(prev => !prev)}
                                        style={{
                                            position: "absolute",
                                            right: 10,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            width: 20,
                                            height: 20,
                                            cursor: "pointer",
                                            opacity: 0.7
                                        }}
                                    />
                                </div>

                                <div style={{ position: "relative", width: "100%" }}>
                                    <input
                                        type={showPasswordConfirm ? "text" : "password"}
                                        placeholder="Confirm password"
                                        value={regPasswordConfirm}
                                        onChange={e => setRegPasswordConfirm(e.target.value)}
                                        required
                                        style={{
                                            padding: "8px 36px 8px 9px",
                                            fontSize: 16,
                                            borderRadius: 6,
                                            border: "1px solid #ccc",
                                            width: "100%",
                                            boxSizing: "border-box"
                                        }}
                                    />

                                    <img
                                        src={showPasswordConfirm ? "/hide.png" : "/show.png"}
                                        alt="toggle visibility"
                                        onClick={() => setShowPasswordConfirm(prev => !prev)}
                                        style={{
                                            position: "absolute",
                                            right: 10,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            width: 20,
                                            height: 20,
                                            cursor: "pointer",
                                            opacity: 0.7
                                        }}
                                    />
                                </div>


                                <input
                                    type="text"
                                    placeholder="Affiliation (University / Institution)"
                                    value={regAffiliation}
                                    onChange={e => setRegAffiliation(e.target.value)}
                                    required
                                    style={{ padding: 8, fontSize: 16, borderRadius: 6, border: "1px solid #ccc" }}
                                />

                                <label style={{ marginTop: "5px", fontWeight: "bold" }}>Intended use:</label>

                                <select
                                    value={regIntendedUse}
                                    onChange={(e) => setRegIntendedUse(e.target.value)}
                                    style={{
                                        padding: 10,
                                        fontSize: 16,
                                        borderRadius: 6,
                                        border: "1px solid #ccc",
                                        width: "100%"
                                    }}
                                >
                                    <option value="Academic use">Academic use</option>
                                    <option value="Policy initiatives">Policy initiatives</option>
                                    <option value="Management of marine areas">Management of marine areas</option>
                                    <option value="General interest in marine environment">General interest in marine environment</option>
                                </select>

                                <div style={{ marginTop: "10px" }}>
                                    <div
                                        id="recaptcha-register"
                                        className="g-recaptcha"
                                        data-sitekey="6LcWBh4sAAAAAFk5yuvXn7hkE0wV-uAmh1dQi2Xz"
                                    ></div>

                                </div>

                                {regError && (
                                    <div
                                        style={{ color: "red", textAlign: "center" }}
                                        dangerouslySetInnerHTML={{ __html: regError }}
                                    ></div>
                                )}



                                <button type="submit" style={{ ...buttonStyle, width: "100%" }}>
                                    Register
                                </button>

                                {!openedFromAdmin && (
                                    <button
                                        type="button"
                                        onClick={() => setAuthMode("login")}
                                        style={{
                                            ...buttonStyle,
                                            backgroundColor: "#ccc",
                                            color: "#222",
                                            width: "100%"
                                        }}
                                    >
                                        Back to login
                                    </button>
                                )}

                            </>

                        )}
                    </form>
                </div>
            )}


            {showAdminPanel && (
                <div
                    style={{
                        position: "fixed",
                        top: 0, left: 0, right: 0, bottom: 0,
                        background: "rgba(0,0,0,0.4)",
                        zIndex: 6000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    onClick={() => setShowAdminPanel(false)}
                >
                    <div
                        onClick={e => e.stopPropagation()}
                        style={{
                            position: "relative",
                            background: "#fff",
                            padding: "25px",
                            borderRadius: "12px",
                            width: "100%",
                            maxWidth: "1000px",
                            maxHeight: "80vh",
                            overflowY: "scroll",
                            boxShadow: "0 5px 20px rgba(0,0,0,0.3)"
                        }}
                    >
                        <button
                            type="button"

                            onClick={() => setShowAdminPanel(false)}
                            style={{
                                position: "absolute",
                                top: "18px",
                                right: "18px",
                                background: "transparent",
                                border: "none",
                                fontSize: "26px",
                                fontWeight: "bold",
                                color: "#777",
                                cursor: "pointer",
                                zIndex: 10,
                                lineHeight: "1"
                            }}
                            aria-label="Close"
                        >
                            ×
                        </button>

                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginBottom: "25px"
                            }}
                        >
                            <button
                                onClick={() => {
                                    setOpenedFromAdmin(true);
                                    setAuthMode("register");
                                    setShowAdminPanel(false);
                                    setShowLoginModal(true);
                                }}
                                style={{
                                    backgroundColor: "#007bff",
                                    color: "white",
                                    padding: "10px 20px",
                                    borderRadius: "10px",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    boxShadow: "0 3px 8px rgba(0,0,0,0.2)"
                                }}
                            >
                                ➕ Create user account
                            </button>


                            <h2 style={{ flex: 1, textAlign: "center", margin: 0 }}>
                                👤 All registered users
                            </h2>

                            <div style={{ width: "160px" }}></div>
                        </div>


                        {adminError && (
                            <div style={{ color: "red", textAlign: "center" }}>{adminError}</div>
                        )}

                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr style={{ background: "#007bff", color: "white" }}>
                                    <th style={{ textAlign: "left", padding: "8px" }}>Name</th>
                                    <th style={{ textAlign: "left", padding: "8px" }}>Surname</th>
                                    <th style={{ textAlign: "left", padding: "8px" }}>Email</th>
                                    <th style={{ textAlign: "left", padding: "8px" }}>Affiliation</th>
                                    <th style={{ textAlign: "left", padding: "8px" }}>Use</th>
                                    <th style={{ textAlign: "left", padding: "8px" }}>Role</th>
                                    <th style={{ textAlign: "left", padding: "8px" }}>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {adminUsers.map(u => (
                                    <tr key={u.id} style={{ borderBottom: "1px solid #ccc" }}>
                                        <td style={{ textAlign: "left", padding: "8px" }}>{u.name}</td>
                                        <td style={{ textAlign: "left", padding: "8px" }}>{u.surname}</td>
                                        <td style={{ textAlign: "left", padding: "8px" }}>{u.email}</td>
                                        <td style={{ textAlign: "left", padding: "8px" }}>{u.affiliation}</td>
                                        <td style={{ textAlign: "left", padding: "8px" }}>{u.intended_use}</td>
                                        <td style={{ textAlign: "left", padding: "8px" }}>{u.role}</td>
                                        <td style={{ textAlign: "left", padding: "8px" }}>
                                            <button
                                                onClick={() => {
                                                    setDeleteUserId(u.id);
                                                    setShowDeleteModal(true);
                                                }}
                                                style={{
                                                    background: "red",
                                                    color: "white",
                                                    padding: "5px 10px",
                                                    borderRadius: "6px",
                                                    cursor: "pointer",
                                                    border: "none"
                                                }}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>

                        </table>
                    </div>
                </div>
            )}



            {showCalcModal && (
                <div
                    style={{
                        position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
                        background: "rgba(0,0,0,0.4)", zIndex: 5001,
                        display: "flex", alignItems: "center", justifyContent: "center"
                    }}
                    onClick={() => setShowCalcModal(false)}
                >
                    <form
                        onSubmit={e => {
                            e.preventDefault();
                            handleCalculate();
                        }}
                        onClick={e => e.stopPropagation()}
                        style={{
                            position: "relative",
                            background: "#fff",
                            padding: "32px 28px",
                            borderRadius: "14px",
                            boxShadow: "0 6px 24px rgba(0,0,0,0.21)",
                            minWidth: 340,
                            display: "flex", flexDirection: "column", gap: 16
                        }}
                    >
                        <button
                            type="button"
                            onClick={() => setShowCalcModal(false)}
                            style={{
                                position: "absolute",
                                top: "18px",
                                right: "18px",
                                background: "transparent",
                                border: "none",
                                fontSize: "26px",
                                fontWeight: "bold",
                                color: "#777",
                                cursor: "pointer",
                                zIndex: 10,
                                lineHeight: "1"
                            }}
                            aria-label="Close"
                        >
                            ×
                        </button>

                        <h2 style={{ margin: 0, marginBottom: 12, textAlign: "center" }}>Calculate SPL</h2>
                        <input
                            type="number"
                            step="any"
                            placeholder="Latitude"
                            value={calcLat}
                            onChange={e => setCalcLat(e.target.value)}
                            required
                            style={{ padding: 8, fontSize: 16, borderRadius: 6, border: "1px solid #ccc" }}
                        />
                        <input
                            type="number"
                            step="any"
                            placeholder="Longitude"
                            value={calcLng}
                            onChange={e => setCalcLng(e.target.value)}
                            required
                            style={{ padding: 8, fontSize: 16, borderRadius: 6, border: "1px solid #ccc" }}
                        />
                      
                        {depthError && (
                            <div style={{ color: "red", fontSize: 14, textAlign: "center" }}>
                                {depthError}
                            </div>
                        )}

                        <button type="submit" style={{ ...buttonStyle, width: "100%" }}>Calculate</button>

                        {calcResult && (
                            <div style={{ marginTop: 18, fontSize: 16 }}>
                                <div><b>SPL:</b> {calcResult.spl?.toFixed(2)} dB re 1 μPa</div>
                            </div>
                        )}
                    </form>
                </div>
            )}



            <button
                onClick={() => setIsSidebarOpen(true)}
                style={{
                    position: "absolute",
                    top: "20px",
                    left: "20px",
                    zIndex: 1200,
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    padding: "10px 15px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "25px",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.3)",
                    display: isSidebarOpen ? "none" : "block"
                }}
            >
                ☰
            </button>

            {isSidebarOpen && (
                <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "250px",
                    bottom: 0,
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    boxShadow: "2px 0 10px rgba(0,0,0,0.2)",
                    zIndex: 1100,
                    display: "flex",
                    flexDirection: "column",
                    padding: "20px",
                    transition: "all 0.3s ease",
                    fontFamily: "Arial, sans-serif"
                }}>
                    <img
                        src={`${process.env.PUBLIC_URL}/SHIPECHO_LOGO.png`}
                        alt="SHIPECHO"
                        style={{
                            width: "120px",
                            display: "block",
                            margin: "-10px auto -32px auto",
                            borderRadius: "12px"
                        }}
                    />

                    <button
                        onClick={() => setIsSidebarOpen(false)}
                        style={{
                            position: "absolute",
                            top: "18px",
                            right: "18px",
                            background: "transparent",
                            border: "none",
                            fontSize: "26px",
                            fontWeight: "bold",
                            color: "#777",
                            cursor: "pointer",
                            zIndex: 10,
                            lineHeight: "1"
                        }}
                        aria-label="Close"
                    >
                        ×
                    </button>


                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: user && user.role === "admin" ? "flex-start" : "center",
                            marginBottom: "18px",
                            marginTop: "12px",
                            marginRight: user && user.role === "admin" ? "30px" : "0px"
                        }}
                    >
                        {user && user.role === "admin" && (
                            <div
                                onClick={() => {
                                    loadUsers();
                                    setShowAdminPanel(true);
                                }}
                                style={{
                                    cursor: "pointer",
                                    fontSize: "30px",
                                    color: "#007bff",
                                    marginTop: "15px",
                                }}
                            >
                                👤
                            </div>
                        )}

                        <h1 style={{ marginBottom: "0px", color: "#007bff", textAlign: "center", width: "100%" }}>
                            Map list
                        </h1>
                    </div>



                    <button
                        onClick={() => {
                            navigate("/live_ais_data");
                            setIsSidebarOpen(false);
                        }}
                        style={{
                            ...buttonStyleSidebar,
                            backgroundColor: (
                                location.pathname === "/live_ais_data" ||
                                location.pathname === "/"
                            ) ? "#0056b3" : "#1485FF",
                            marginBottom: "10px"
                        }}
                    >
                        🚢 Live vessel
                    </button>

                    <button
                        onClick={() => {
                            navigate("/ais_past_data");
                            setIsSidebarOpen(false);
                        }}
                        style={{
                            ...buttonStyleSidebar,
                            backgroundColor: location.pathname === "/ais_past_data" ? "#0056b3" : "#1485FF",
                            marginBottom: "10px"
                        }}
                    >
                        📅 Historical data
                    </button>





                    <button
                        onClick={() => {
                            navigate("/sel_ais_data_all");
                            setIsSidebarOpen(false);
                        }}
                        style={{
                            ...buttonStyleSidebar,
                            backgroundColor: location.pathname === "/sel_ais_data_all" ? "#0056b3" : "#1485FF"
                        }}
                    >
                        Sound exposure level
                    </button>
                    <hr style={{ margin: "15px 0" }} />
                    {!user ? (
                        <button
                            onClick={openLogin}
                            style={{ ...buttonStyleSidebar, backgroundColor: "#00a", marginBottom: "10px" }}
                        >
                            Login/Register
                        </button>

                    ) : (
                        <button
                            onClick={() => {
                                sessionStorage.removeItem("jwtToken");
                                sessionStorage.removeItem("user");

                                setIsLoggedIn(false);

                                setShowLoginModal(false);
                                setAuthMode("login");
                                setMapKey(k => k + 1);

                            }}

                            style={{ ...buttonStyleSidebar, backgroundColor: "#b33", marginBottom: "10px" }}
                        >
                            Logout
                        </button>

                    )}


                    {user && user.role === "admin" && (
                        <button
                            onClick={() => {
                                setShowVisitorStats(prev => !prev);
                                setIsSidebarOpen(false);
                            }}
                            style={{ ...buttonStyleSidebar, backgroundColor: "#6f42c1", marginBottom: "10px" }}
                        >
                            👥 Visitor Tracking
                        </button>
                    )}

                    <button
                        onClick={() => window.open('https://www.sciencedirect.com/science/article/pii/S0964569126002954?via%3Dihub', '_blank')}
                        style={{ ...buttonStyleSidebar, backgroundColor: "#198754" }}
                    >
                        📄 Documentation
                    </button>

                    <div style={{ flex: 1 }} />

                    <div style={{ marginTop: "auto", paddingTop: 12 }}>
                        <a
                            href="https://marsci.haifa.ac.il/en/school/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                        <img
                            src={`${process.env.PUBLIC_URL}/CSMS.jpeg`}
                            alt="Leon H. Charney School of Marine Sciences"
                            style={{
                                width: "100%",
                                height: "auto",
                                display: "block",
                                borderRadius: "8px",
                                marginBottom: "10px",
                            }}
                        />
                        </a>
                        <div
                            style={{
                                position: "relative",
                                marginBottom: "10px",
                            }}
                        >

                            <div
                                style={{
                                    backgroundColor: "#fff",
                                    borderRadius: "8px",
                                    width: "100%",
                                    height: "100%",
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    zIndex: 1,
                                }}
                            ></div>
                            <a
                                href="https://marble.eu/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                            <img
                                src={`${process.env.PUBLIC_URL}/marble_logo.png`}
                                alt="Marble Logo"
                                style={{
                                    width: "100%",
                                    height: "auto",
                                    display: "block",
                                    borderRadius: "8px",
                                    position: "relative",
                                    marginTop: "-10px",
                                    zIndex: 2,

                                }}
                            />
                            </a>
                        </div>


                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "-48px",
                            }}
                        >
                            <a
                                href="https://sites.google.com/edu.haifa.ac.il/anl"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                            <img
                                src={`${process.env.PUBLIC_URL}/ANL.png`}
                                alt="ANL - Haifa"
                                style={{ height: "140px", objectFit: "cover", objectPosition: "center top" }}
                            />
                            </a>
                            <a
                                href="https://uwin-labust.fer.hr/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                            <img
                                src={`${process.env.PUBLIC_URL}/UWIN.png`}
                                alt="ANL - Haifa"
                                style={{ height: "140px", objectFit: "cover", objectPosition: "center top" }}
                            />
                            </a>

                        </div>
                    </div>


                </div>
            )}

            {showVisitorStats && (
                <div style={{
                    position: "absolute",
                    top: "110px",
                    right: "10px",
                    width: "420px",
                    maxHeight: "76vh",
                    overflowY: "auto",
                    background: "rgba(255,255,255,0.98)",
                    borderRadius: "14px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.22)",
                    zIndex: 1300,
                    padding: "14px"
                }}>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px"
                    }}>
                        <h2 style={{ margin: 0, fontSize: "1rem", color: "#007bff" }}>Visitor Tracking</h2>
                        <button
                            type="button"
                            onClick={() => setShowVisitorStats(false)}
                            style={{
                                border: "none",
                                background: "transparent",
                                fontSize: "20px",
                                cursor: "pointer",
                                color: "#777"
                            }}
                        >
                            ×
                        </button>
                    </div>
                    <VisitorStats />
                </div>
            )}

            <div style={{
                position: "absolute",
                width: "400px",
                top: 20,
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 1000,
                background: "rgba(248, 249, 250, 0.9)",
                padding: "20px",
                borderRadius: "10px",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
                fontFamily: "Arial, sans-serif",
                color: "#333"
            }}>
                <h1 style={{
                    textAlign: "center",
                    fontWeight: 2000,
                    fontSize: "1.8rem",
                    letterSpacing: "0.5px",
                    marginBottom: "12px",
                    color: "#155fa0",
                    textShadow: "0 1px 4px #e7ecf7, 0 1px 0 #fff",
                    marginTop: "0px"
                }}>
                    Live noise map data               </h1>




                <div style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "7px" }}>
                        <div style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "12px" }}>
                            {currentTime ? currentTime.toLocaleString(undefined, {
                                hour: "2-digit",
                                minute: "2-digit",
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour12: false
                            }) : ""}


                        </div>

                        <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "0px" }}>




                        </div>
                    </div>







                    <div
                        style={{
                            position: "absolute",
                            top: "100px",
                            left: "10px",
                            backgroundColor: "rgba(255, 255, 255, 0.7)",
                            padding: "5px",
                            borderRadius: "5px",
                            fontSize: "14px",
                            fontWeight: "bold",
                            zIndex: 1000,
                        }}
                    >
                    </div>




                </div>
            </div>

            {heatmapLoading && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(255,255,255,0.6)",
                    zIndex: 2500,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    pointerEvents: "all",
                    cursor: "wait"
                                    }}>
                    <div style={{
                        fontSize: "26px",
                        fontWeight: "bold",
                        color: "#007bff",
                        marginBottom: "10px"
                    }}>
                        Loading noise map…
                    </div>

                    <div style={{
                        fontSize: "16px",
                        color: "#007bff"
                    }}>
                        Applying model & frequency band
                    </div>
                </div>
            )}


            {mpaLoading && (
                <div style={{
                    position: "fixed",
                    top: 0, left: 0, right: 0, bottom: 0,
                    background: "rgba(255,255,255,0.7)",
                    zIndex: 3000,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <div style={{ marginTop: "20px", fontWeight: "bold", fontSize: "25px", color: "#007bff" }}>
                        Loading marine protected areas...
                    </div>

                    <div style={{ fontWeight: "normal", fontSize: "18px", color: "#007bff", marginTop: "5px" }}>
                        This may take a few second.
                    </div>
                </div>
            )}

            {showDeleteModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0, left: 0, right: 0, bottom: 0,
                        background: "rgba(0,0,0,0.4)",
                        zIndex: 7000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    onClick={() => setShowDeleteModal(false)}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            background: "white",
                            padding: "25px",
                            borderRadius: "12px",
                            width: "350px",
                            textAlign: "center",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.3)"
                        }}
                    >
                        <h3 style={{ marginBottom: "20px" }}>
                            Are you sure you want to delete this user?
                        </h3>

                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <button
                                style={{
                                    background: "red",
                                    color: "white",
                                    padding: "10px 20px",
                                    borderRadius: "8px",
                                    border: "none",
                                    cursor: "pointer",
                                    width: "45%"
                                }}
                                onClick={() => {
                                    deleteUser(deleteUserId);
                                    setShowDeleteModal(false);
                                }}
                            >
                                <h3 >
                                    Yes
                                </h3>
                            </button>

                            <button
                                style={{
                                    background: "#ccc",
                                    color: "#000",
                                    padding: "10px 20px",
                                    borderRadius: "8px",
                                    border: "none",
                                    cursor: "pointer",
                                    width: "45%"
                                }}
                                onClick={() => setShowDeleteModal(false)}
                            >
                                <h3 >
                                    No
                                </h3>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showRegisterSuccess && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            padding: "30px",
                            borderRadius: "10px",
                            width: "350px",
                            position: "relative",
                            textAlign: "center",
                            boxShadow: "0 4px 15px rgba(0,0,0,0.3)"
                        }}
                    >
                        <button
                            onClick={() => setShowRegisterSuccess(false)}
                            style={{
                                position: "absolute",
                                top: "18px",
                                right: "18px",
                                background: "transparent",
                                border: "none",
                                fontSize: "23px",
                                fontWeight: "bold",
                                color: "#777",
                                cursor: "pointer",
                                zIndex: 10,
                                lineHeight: "1"
                            }}
                        >
                            ×
                        </button>

                        <h2 style={{ marginBottom: "20px" }}>Successful registration!</h2>

                        <button
                            onClick={() => setShowRegisterSuccess(false)}
                            style={{
                                padding: "3px 25px",
                                backgroundColor: "#007bff",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                cursor: "pointer",
                                fontWeight: "bold",
                                marginTop: "5px"
                            }}
                        >
                            <h2> OK</h2>
                        </button>
                    </div>
                </div>
            )}


            <MapGL
                key={mapKey}
                ref={mapRef}
                mapLib={import("maplibre-gl")}
                onClick={(e) => {
                    if (isPickingLocation) {
                        const { lng, lat } = e.lngLat;
                        setCalcLat(lat.toFixed(6));
                        setCalcLng(lng.toFixed(6));
                      

                        fetch(`${API_BASE}/api/depths`, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify([{ lat, lon: lng }])
                        })
                            .then(res => res.json())
                            .then(data => {
                                if (data.depths && data.depths[0] !== null) {
                                    setActualDepth(data.depths[0]);
                                } else {
                                    setActualDepth(null);
                                }
                            })
                            .catch(err => {
                                console.error("Depth fetch error:", err);
                                setActualDepth(null);
                            });

                        setIsPickingLocation(false);
                        const map = mapRef.current?.getMap();
                        if (map) map.getCanvas().style.cursor = "";
                        if (pickHintRef.current) pickHintRef.current.style.display = "none";
                        setShowCalcModal(true);
                        return;
                    }



                    setSelectedShip(null);
                    if (isSidebarOpen) setIsSidebarOpen(false);
                }}

                initialViewState={{
                    longitude: 25.9,
                    latitude: 40.72,
                    zoom: 4,
                    maxZoom: 10.2,
                    minZoom: 3.5
                }}
                style={{ flex: 1, width: "100%" }}
                mapStyle="https://api.maptiler.com/maps/0195ec7d-c124-7e8f-85b1-bb0602899c0e/style.json?key=sDvAXBg4VEXfXMSAABi9"

                onLoad={() => {
                    const map = mapRef.current.getMap();
                    setMapReady(true);

                    const layers = map.getStyle().layers;

                    if (layers.find(layer => layer.id === 'Depth labels')) {
                        map.moveLayer('Depth labels');
                    } else {
                        console.log("Layer 'Depth labels' does not exist yet.");
                    }
                    if (layers.find(layer => layer.id === 'Terrain RGB')) {
                        map.moveLayer('Terrain RGB');
                    } else {
                        console.log("Layer 'Terrain RGB' does not exist yet.");
                    }



                    if (layers.find(layer => layer.id === 'Lake')) {
                        map.moveLayer('Lake');
                    } else {
                        console.log("Layer 'Lake' does not exist yet.");
                    }

                    if (layers.find(layer => layer.id === 'Rivers')) {
                        map.moveLayer('Rivers');
                    } else {
                        console.log("Layer 'Rivers' does not exist yet.");
                    }

                    if (layers.find(layer => layer.id === 'Island labels')) {
                        map.moveLayer('Island labels');
                    } else {
                        console.log("Layer 'Island labels' does not exist yet.");
                    }

                }}
                onMove={(e) => {
                    const newZoom = e.viewState.zoom;
                    setZoomLevel(parseFloat(newZoom.toFixed(0)));
                }}
            >






                {showIcons && visibleShips.map((ship, index) => (
                    <Marker
                        key={index}
                        longitude={ship.LONGITUDE}
                        latitude={ship.LATITUDE}
                        anchor="center"
                        onClick={(e) => {
                            e.originalEvent.stopPropagation();
                            setSelectedShip(ship);
                        }}
                    >
                        <img
                            src={getShipIcon(ship.AISTYPE, ship.COURSE)?.options?.html?.match(/src="([^"]+)"/)?.[1] || "IconPurple1.png"}
                            alt="ship"
                            style={{
                                width: `${getSmoothShipIconSize(zoomLevel)}px`,
                                height: `${getSmoothShipIconSize(zoomLevel)}px`,
                                transform: `rotate(${ship.COURSE || 0}deg)`,
                                cursor: "pointer",
                                transition: "width 0.22s cubic-bezier(0.32, 0.72, 0.46, 1), height 0.22s cubic-bezier(0.32, 0.72, 0.46, 1)",
                                willChange: "width, height"
                            }}
                        />

                    </Marker>
                ))}



                {selectedShip && (
                    <Popup
                        longitude={selectedShip.LONGITUDE}
                        latitude={selectedShip.LATITUDE}
                        anchor="top"
                        closeOnClick={false}
                        onClose={() => setSelectedShip(null)}
                        style={{ maxWidth: "300px", minWidth: "300px" }}

                    >
                        <div style={{ lineHeight: "1.5", fontSize: "13.5px" }}>
                            <strong>{selectedShip.NAME || "Unknown vessel"}</strong><br />
                            MMSI: {selectedShip.MMSI}<br />
                            Type: {getShipDescription(selectedShip.AISTYPE)}<br />
                            Speed: {selectedShip.SPEED?.toFixed?.(1) || 0} knots<br />
                            Course: {selectedShip.COURSE}°<br />
                            Time: {selectedShip[timeColumn]}<br />

                            {(() => {
                                const length = getVesselLength(selectedShip);
                                const beam = (Number(selectedShip.C) || 0) + (Number(selectedShip.D) || 0);
                                const draftInfo = getEstimatedDraught(selectedShip);
                                let noise;

                                noise = calculateNoiseByModel(selectedShip, selectedModel, selectedBand);


                                return (
                                    <>

                                        <span>Length: {length.toFixed(1)} m</span><br />
                                        <span>Draft: {draftInfo.label}</span><br />
                                        {selectedShip.SPEED < 2 ? (
                                            <span>Noise Source Level: N/A</span>
                                        ) : noise === null ? (
                                            <span>Noise Source Level: not supported for this type of vessel</span>
                                        ) : (
                                            <span>{selectedBand === "Broadband"
                                                ? "Noise Source Level: " + noise.toFixed(2) + " dB re 1 μPa @ 1m"
                                                : "Noise Source Level: " + noise.toFixed(2) + " dB re 1 μPa @ 1m"
                                            }
                                            </span>
                                        )}

                                    </>
                                );
                            })()}
                        </div>
                    </Popup>

                )}

                <div style={{
                    position: "absolute",
                    bottom: 74,
                    right: 10,
                    backgroundColor: "white",
                    padding: "10px",
                    borderRadius: "5px",
                    boxShadow: "0 2 5px rgba(0,0,0,0.3)",
                    zIndex: 1000,
                    fontSize: "14px",
                    marginBottom: "170px",
                }}>





                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        

                        <label>
                            <input
                                type="checkbox"
                                checked={showIcons}
                                onChange={() => setShowIcons(prev => !prev)}
                            />
                            Vessel Icons
                        </label>

                        <label>
                            <input
                                type="checkbox"
                                checked={showHeatmap}
                                onChange={() => setShowHeatmap(prev => !prev)}
                            />
                            Noise Heatmap
                        </label>

                        <label style={{ cursor: "pointer" }}>
                            <input
                                type="checkbox"
                                checked={showMPA}
                                onChange={(e) => {
                                    const checked = e.target.checked;
                                    setShowMPA(checked);

                                    if (checked) {
                                        setMpaLoading(true);
                                    } else {
                                        setMpaLoading(false);
                                    }
                                }}
                            />

                            Marine protected areas
                        </label>

                    </div>
                </div>



                <div style={{
                    position: "absolute",
                    bottom: 1,
                    right: 10,
                    backgroundColor: "white",
                    padding: "10px",
                    borderRadius: "5px",
                    boxShadow: "0 2 5px rgba(0,0,0,0.3)",
                    zIndex: 1000,
                    fontSize: "14px",
                    marginBottom: "170px",
                }}>


                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        <label>
                            <input
                                type="checkbox"
                                checked={showNavstat0}
                                onChange={() => setShowNavstat0(prev => !prev)}
                            />
                            ⚓️Vessel at anchor
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                checked={showNavstat1}
                                onChange={() => setShowNavstat1(prev => !prev)}
                            />
                            🚢Underway using engine vessel
                        </label>
                    </div>

                </div>



                {showShipIconLegend && (() => {
                    const relevantTypes = getRelevantVesselTypesForModel(selectedModel);
                    const vesselLegend = [
                        { name: "Passenger", label: "Passenger vessels", icon: "IconBlue1.png" },
                        { name: "Cargo", label: "Cargo vessels", icon: "IconYellow1.png" },
                        { name: "Tankers", label: "Tankers", icon: "IconGray1.png" },
                        { name: "Sailing", label: "Sailing vessel", icon: "IconRed1.png" },
                        { name: "Pleasure", label: "Pleasure Craft", icon: "IconOrange1.png" },
                        { name: "Fishing", label: "Fishing vessel", icon: "IconPurple1.png" }
                    ];

                    return (
                        <div
                            style={{
                                position: "absolute",
                                bottom: "40px",
                                left: "10px",
                                backgroundColor: "rgb(255, 255, 255)",
                                padding: "10px",
                                borderRadius: "10px",
                                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)",
                                zIndex: 1000,
                                fontSize: "14px",
                            }}
                        >
                            <div style={{ textAlign: "center", marginBottom: "6px" }}>
                                <strong>Vessel type</strong>
                            </div>

                            {vesselLegend.map(v => (
                                <div key={v.name} style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                                    <img
                                        src={v.icon}
                                        style={{ width: "15px", verticalAlign: "middle", marginRight: "5px" }}
                                        alt={v.label}
                                    />
                                    <span>{v.label}</span>
                                    {relevantTypes.includes(v.name) && (
                                        <span style={{ color: "green", fontWeight: "bold", marginLeft: "6px" }}>✔</span>
                                    )}
                                </div>
                            ))}
                        </div>
                    );
                })()}

               
                {showHeatmap && (
                    <>
                        <Source id="gaussian" type="geojson" data={gaussianGeoJSON}>
                            <Layer
                                id="gaussian-heat"
                                type="heatmap"
                                paint={{
                                    "heatmap-weight": [
                                        "interpolate",
                                        ["linear"],
                                        ["get", "spl"],
                                        80, 0,
                                        200, 1
                                    ],
                                    "heatmap-radius": 45,
                                    "heatmap-intensity": 1.4,
                                    "heatmap-opacity": 0.9
                                }}
                            />
                        </Source>
                        <Source id="heatmap-jadran-sjever" type="geojson" data={sjeverni_jadran}>
                            <Layer
                                id="heatmap-jadran-sjever"
                                type="heatmap"
                                beforeId="mask-land-fill"
                                paint={{
                                    "heatmap-weight": ["get", "weight"],
                                    "heatmap-radius": [
                                        "interpolate", ["linear"], ["zoom"],
                                        3, ["*", ["get", "radius"], isSRV ? 0.06 : 0.04],
4, ["*", ["get", "radius"], isSRV ? 0.07 : 0.05],
5, ["*", ["get", "radius"], isSRV ? 0.08 : 0.06],
6, ["*", ["get", "radius"], isSRV ? 0.11 : 0.10],
7, ["*", ["get", "radius"], isSRV ? 0.18 : 0.16],
8, ["*", ["get", "radius"], isSRV ? 0.30 : 0.24],
9, ["*", ["get", "radius"], isSRV ? 0.65 : 0.50],
10, ["*", ["get", "radius"], isSRV ? 1.35 : 1.00],
11, ["*", ["get", "radius"], isSRV ? 2.55 : 1.95],
12, ["*", ["get", "radius"], isSRV ? 4.80 : 3.80],
13, ["*", ["get", "radius"], isSRV ? 8.80 : 7.00],
                                    ],
                                    "heatmap-intensity": [
                                        "interpolate", ["linear"], ["zoom"],
                                        2, 0.003 * intensityMultiplier,
                                        10, 1.1 * intensityMultiplier,
                                    ],
                                    "heatmap-color": [
                                        "interpolate", ["linear"], ["min", ["heatmap-density"], 0.75],
                                        0, "rgba(0, 128, 0, 0)",
                                        0.1, "#00cc00",
                                        0.25, "#ccff00",
                                        0.4, "#ffff00",
                                        0.55, "#ffcc00",
                                        0.7, "#ff8000",
                                        0.75, "#ff8000"
                                    ],
                                    "heatmap-opacity": 0.8
                                }}
                            />
                        </Source>

                        <Source id="heatmap-jadran-jug" type="geojson" data={juzni_jadran}>
                            <Layer
                                id="heatmap-jadran-jug"
                                type="heatmap"
                                beforeId="mask-land-fill"
                                paint={{
                                    "heatmap-weight": ["get", "weight"],
                                    "heatmap-radius": [
                                        "interpolate", ["linear"], ["zoom"],
                                        3, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.04],
                                        4, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.05],
                                        5, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.06],
                                        6, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.1],
                                        7, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.16],
                                        8, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.24],
                                        9, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.5],
                                        10, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 1.0],
                                        11, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 1.95],
                                        12, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 3.8],
                                        13, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 7],
                                    ],
                                    "heatmap-intensity": [
                                        "interpolate", ["linear"], ["zoom"],
                                        2, 0.003 * intensityMultiplier,
                                        10, 1.5 * intensityMultiplier,
                                    ],
                                    "heatmap-color": [
                                        "interpolate", ["linear"], ["min", ["heatmap-density"], 0.75],
                                        0, "rgba(0, 128, 0, 0)",
                                        0.1, "#00cc00",
                                        0.25, "#ccff00",
                                        0.4, "#ffff00",
                                        0.55, "#ffcc00",
                                        0.7, "#ff8000",
                                        0.75, "#ff8000"
                                    ],
                                    "heatmap-opacity": 0.8
                                }}
                            />
                        </Source>

                        <Source id="ship-noise-heatmap-haifa-jug" type="geojson" data={haifa_jug}>
                            <Layer
                                id="ship-noise-heat-haifa-jug"
                                type="heatmap"
                                beforeId="mask-land-fill"
                                paint={{
                                    "heatmap-weight": ["get", "weight"],
                                    "heatmap-radius": [
                                        "interpolate", ["linear"], ["zoom"],
                                        3, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.04],
                                        4, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.05],
                                        5, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.06],
                                        6, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.1],
                                        7, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.16],
                                        8, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.24],
                                        9, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.5],
                                        10, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 1.0],
                                    ],

                                    "heatmap-intensity": [
                                        "interpolate", ["linear"], ["zoom"],
                                        2, 0.01 * intensityMultiplier,
                                        10, 1.6 * intensityMultiplier,
                                    ],
                                    "heatmap-color": [
                                        "interpolate", ["linear"], ["min", ["heatmap-density"], 0.75],
                                        0, "rgba(0, 128, 0, 0)",
                                        0.1, "#00cc00",
                                        0.25, "#ccff00",
                                        0.4, "#ffff00",
                                        0.55, "#ffcc00",
                                        0.7, "#ff8000",
                                        0.75, "#ff8000"
                                    ],
                                    "heatmap-opacity": 0.8
                                }}
                            />
                        </Source>

                        <Source id="ship-noise-heatmap-haifa-sjever" type="geojson" data={haifa_sjever}>
                            <Layer
                                id="ship-noise-heatmap-haifa-sjever"
                                type="heatmap"
                                beforeId="mask-land-fill"
                                paint={{
                                    "heatmap-weight": ["get", "weight"],
                                    "heatmap-radius": [
                                        "interpolate", ["linear"], ["zoom"],
                                        3, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.04],
                                        4, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.05],
                                        5, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.06],
                                        6, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.1],
                                        7, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.16],
                                        8, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.24],
                                        9, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.5],
                                        10, ["*", ["get", "radius"],],

                                    ],
                                    "heatmap-intensity": [
                                        "interpolate", ["linear"], ["zoom"],
                                        2, 0.01 * intensityMultiplier,
                                        10, 1.7 * intensityMultiplier,
                                    ],
                                    "heatmap-color": [
                                        "interpolate", ["linear"], ["min", ["heatmap-density"], 0.75],
                                        0, "rgba(0, 128, 0, 0)",
                                        0.1, "#00cc00",
                                        0.25, "#ccff00",
                                        0.4, "#ffff00",
                                        0.55, "#ffcc00",
                                        0.7, "#ff8000",
                                        0.75, "#ff8000"
                                    ],
                                    "heatmap-opacity": 0.8
                                }}
                            />
                        </Source>


                        <Source id="heatmap-uk" type="geojson" data={uk}>
                            <Layer
                                id="heatmap-uk"
                                type="heatmap"
                                beforeId="mask-land-fill"
                                paint={{
                                    "heatmap-weight": ["get", "weight"],
                                    "heatmap-radius": [
                                        "interpolate", ["linear"], ["zoom"],
                                        3, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.04],
                                        4, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.05],
                                        5, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.06],
                                        6, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.1],
                                        7, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.16],
                                        8, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.24],
                                        9, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.5],
                                        10, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 1.0],
                                        11, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 1.95],
                                        12, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 3.8],
                                        13, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 7],
                                    ],
                                    "heatmap-intensity": [
                                        "interpolate", ["linear"], ["zoom"],
                                        2, 0.003 * intensityMultiplier,
                                        10, 1.2 * intensityMultiplier,
                                    ],
                                    "heatmap-color": [
                                        "interpolate", ["linear"], ["min", ["heatmap-density"], 0.75],
                                        0, "rgba(0, 128, 0, 0)",
                                        0.1, "#00cc00",
                                        0.25, "#ccff00",
                                        0.4, "#ffff00",
                                        0.55, "#ffcc00",
                                        0.7, "#ff8000",
                                        0.75, "#ff8000"
                                    ],

                                    "heatmap-opacity": 0.8
                                }}
                            />
                        </Source>

                        {/*          <Source id="heatmap-spain-region" type="geojson" data={spain_region}>
                            <Layer
                                id="heatmap-spain-region"
                                type="heatmap"
                                beforeId="mask-land-fill"
                                paint={{
                                    "heatmap-weight": ["get", "weight"],
                                    "heatmap-radius": [
                                        "interpolate", ["linear"], ["zoom"],
                                        3, ["*", ["get", "radius"], 0.04],
                                        4, ["*", ["get", "radius"], 0.05],
                                        5, ["*", ["get", "radius"], 0.06],
                                        6, ["*", ["get", "radius"], 0.1],
                                        7, ["*", ["get", "radius"], 0.16],
                                        8, ["*", ["get", "radius"], 0.24],
                                        9, ["*", ["get", "radius"], 0.5],
                                        10, ["*", ["get", "radius"], 1.0],
                                        11, ["*", ["get", "radius"], 1.95],
                                        12, ["*", ["get", "radius"], 3.8],
                                        13, ["*", ["get", "radius"], 7],
                                    ],
                                    "heatmap-intensity": [
                                        "interpolate", ["linear"], ["zoom"],
                                        2, 0.003 * intensityMultiplier,
                                        10, 1.1 * intensityMultiplier,
                                    ],
                                  "heatmap-color": [
                                        "interpolate", ["linear"], ["min", ["heatmap-density"], 0.75],
                                        0, "rgba(0, 128, 0, 0)",
                                        0.1, "#00cc00",
                                        0.25, "#ccff00",
                                        0.4, "#ffff00",
                                        0.55, "#ffcc00",
                                        0.7, "#ff8000",
                                        0.75, "#ff8000"
                                    ],
                                    "heatmap-opacity": 0.8
                                }}
                            />
                        </Source> 
                        */}

                        <Source id="heatmap-north" type="geojson" data={north}>
                            <Layer
                                id="heatmap-north"
                                type="heatmap"
                                beforeId="mask-land-fill"
                                paint={{
                                    "heatmap-weight": ["get", "weight"],
                                    "heatmap-radius": [
                                        "interpolate", ["linear"], ["zoom"],
                                        3, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.04],
                                        4, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.05],
                                        5, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.06],
                                        6, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.1],
                                        7, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.16],
                                        8, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.24],
                                        9, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 0.5],
                                        10, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 1.0],
                                        11, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 1.95],
                                        12, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 3.8],
                                        13, ["*", ["get", "radius"], isSRV ? 0.1 * SRV_RADIUS_BOOST : 7],
                                    ],
                                    "heatmap-intensity": [
                                        "interpolate", ["linear"], ["zoom"],
                                        2, 0.003 * intensityMultiplier,
                                        10, 1.1 * intensityMultiplier,
                                    ],
                                    "heatmap-color": [
                                        "interpolate", ["linear"], ["min", ["heatmap-density"], 0.75],
                                        0, "rgba(0, 128, 0, 0)",
                                        0.1, "#00cc00",
                                        0.25, "#ccff00",
                                        0.4, "#ffff00",
                                        0.55, "#ffcc00",
                                        0.7, "#ff8000",
                                        0.75, "#ff8000"
                                    ],
                                    "heatmap-opacity": 0.8
                                }}
                            />
                        </Source>
                    </>
                )}


                <Source
                    id="mask-land"
                    type="vector"
                    tiles={["https://api.maptiler.com/tiles/land/{z}/{x}/{y}.pbf?key=sDvAXBg4VEXfXMSAABi9"]}
                >
                    <Layer
                        id="mask-land-fill"
                        source="mask-land"
                        source-layer="land"
                        type="fill"
                        paint={{
                            "fill-color": "#E0E0E0",
                            "fill-opacity": 0.9999999999999
                        }}
                    />
                </Source>



                {showHeatmapLegend && (
                    <div
                        style={{
                            position: "absolute",
                            bottom: "40px",
                            right: "10px",
                            backgroundColor: "rgb(255, 255, 255)",
                            padding: "12px",
                            borderRadius: "10px",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)",
                            zIndex: 1000,
                            fontSize: "14px",
                            width: "280px",
                        }}
                    >
                        <h4 style={{ textAlign: "center", marginBottom: "12px", fontSize: "13px" }}>
                            Sound Pressure Level (SPL) [dB re 1 μPa]
                        </h4>

                        <div
                            style={{
                                width: "100%",
                                height: "20px",
                                background: "linear-gradient(to right, #00cc00 0%, #ccff00 20%, #ffff00 40%, #ffcc00 60%, #ff8000 75%, #ff3300 90%, #cc0000 100%)",
                                borderRadius: "5px",
                                marginBottom: "8px"
                            }}
                        ></div>

                        <div
    style={{
        display: "flex",
        justifyContent: "space-between",
        fontSize: "12px",
        color: "#333",
        fontWeight: "bold",
        gap: "6px"
    }}
>
    {legendTicks.map((tick, idx) => (
        <span
            key={idx}
            style={{
                flex: 1,
                textAlign:
                    idx === 0 ? "left" :
                    idx === legendTicks.length - 1 ? "right" :
                    "center"
            }}
        >
            {tick}
        </span>
    ))}
</div>

                    </div>
                )}

                <div style={{
                    position: "absolute",
                    bottom: "41px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 2000,
                    backgroundColor: "rgba(255,255,255,0.9)",
                    padding: "12px 20px",
                    borderRadius: "8px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                    display: "flex",
                }}>
                    <div>
                        <div style={{ fontWeight: "bold", fontSize: "14px", color: "black", marginBottom: "5px" }}>Frequency Bands:</div>
                        <div style={{ display: "flex", gap: "6px" }}>
                            <button
                                style={{
                                    ...buttonStyle,
                                    height: "50px",
                                    backgroundColor: selectedBand === "63Hz" ? "#0056b3" : "#1485FF",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    lineHeight: "1.2",
                                    padding: "6px 12px"
                                }}
                                onClick={() => setSelectedBand("63Hz")}
                            >
                                63 Hz
                            </button>

                            <button
                                style={{
                                    ...buttonStyle,
                                    height: "50px",
                                    backgroundColor: selectedBand === "125Hz" ? "#0056b3" : "#1485FF",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    lineHeight: "1.2",
                                    padding: "6px 12px"
                                }}
                                onClick={() => setSelectedBand("125Hz")}
                            >
                                125 Hz
                            </button>

                            <button
                                style={{
                                    ...buttonStyle,
                                    height: "50px",
                                    backgroundColor: selectedBand === "Broadband" ? "#0056b3" : "#1485FF",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    lineHeight: "1.2",
                                    padding: "6px 12px"
                                }}
                                onClick={() => setSelectedBand("Broadband")}
                            >
                                Broadband<br />(20–2000 Hz)
                            </button>
                        </div>
                    </div>

                </div>


                <div style={{
                    position: "absolute",
                    bottom: 175,
                    right: 10,
                    backgroundColor: "white",
                    padding: "10px",
                    borderRadius: "5px",
                    boxShadow: "0 2 5px rgba(0,0,0,0.3)",
                    zIndex: 1000,
                    fontSize: "14px",
                    marginBottom: "170px",
                }}>
                    <label htmlFor="model-select" style={{ fontWeight: "bold", color: "black" }}>Model:</label>
                    <select
                        id="model-select"
                        value={selectedModel}
                        onChange={(e) => {
                            setSelectedModel(e.target.value);
                            setIsSelectOpen(false);
                        }}
                        onMouseDown={() => setIsSelectOpen(true)}
                        onBlur={() => setIsSelectOpen(false)}
                        style={selectBoxStyle}
                    >
                        {isSelectOpen ? (
                            <>
                                <option value="RANDI">RANDI 3.1 (Breeding et al., 1996)</option>
                                <option value="JOMOPANS">JOMOPANS-ECHO (MacGillivray & de Jong, 2021)</option>
                                <option value="LBDS">LBDS (Simard et al., 2016)</option>
                                <option value="AQUO">AQUO (Audoly & Rizzuto, 2015)</option>
                                <option value="SMALL_VESSEL">SRV MODEL</option>
                                <option value="AVERAGE">COMBINED (Displays the average of all models for that vessel type )</option>


                            </>
                        ) : (
                            <>
                                <option value="RANDI">RANDI</option>
                                <option value="JOMOPANS">JOMOPANS</option>
                                <option value="LBDS">LBDS</option>
                                <option value="AQUO">AQUO</option>
                                <option value="SMALL_VESSEL">SRV MODEL</option>
                                <option value="AVERAGE">COMBINED</option>


                            </>
                        )}
                    </select>
                </div>

                {/*
              
                <Source
                    id="ship-noise-heat"
                    type="geojson"
                    data={{
                        type: "FeatureCollection",
                        features: [
                            ...(sjeverni_jadran.features ?? []),
                            ...(juzni_jadran.features ?? []),
                            ...(haifa_jug.features ?? []),
                            ...(haifa_sjever.features ?? []),
                            ...(uk.features ?? []),
                            ...(spain_region.features ?? []),
                            ...(north_europe.features ?? []),
                            ...(north.features ?? []),
                        ]
                    }}
                >
        

                    <Layer
                        id="ray-dots"
                        type="circle"
                        paint={{
                            "circle-radius": 4,
                            "circle-color": "#ff0000",
                            "circle-opacity": 0.9
                        }}
                    />

                    <Layer
                        id="ray-colored"
                        type="circle"
                        paint={{
                            "circle-radius": 5,
                            "circle-color": [
                                "interpolate",
                                ["linear"],
                                ["get", "ring"],
                                0.25, "red",
                                0.50, "blue"
                            ]

                        }}
                    />
                </Source>
*/}

                {showMPA && (
                    <Source
                        id="mpa"
                        type="geojson"
                        data={process.env.PUBLIC_URL + "/mpa/merged_mpa_global_marine.geojson"}
                    >
                        <Layer
                            id="mpa-outline"
                            type="line"
                            paint={{
                                "line-color": "#000000",
                                "line-width": 2,
                                "line-dasharray": [2, 2],
                                "line-opacity": 0.9
                            }}
                        />
                    </Source>
                )}

                 <div
    style={{
        position: "absolute",
        bottom: "20px",
        left: "20px",
        zIndex: 30
    }}
>
    <ScaleControl
        position="bottom-left"
        maxWidth={120}
        unit="metric"
    />
</div>

            </MapGL>




        </div>
    );
};

export default ShipMap;



